import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorage } from 'ngx-store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/Subscription';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ImageResult } from 'ngx-image2dataurl';
import { formatDate } from '@angular/common';
import { BehaviorSubject, combineLatest, ReplaySubject, Subject } from 'rxjs';
import { pluck, takeUntil, tap } from "rxjs/operators";
import { BreachRequest } from '../../breach/breach';
import { environment } from '../../../../environments/environment';

//Model
import { RunNote } from '../../../model/notes.model';
import { ThemeSetting, Url, User } from '../../../model/users.model';
import { NonCompliance } from '../../../model/non-compliance.model';
import { Fleet } from 'src/app/model/fleet.model';
import { RunEquipment, RunAction, RunDriver, RunPlanActivity, GeofenceRadius, Location, Connote, ConnoteSite, Run } from 'src/app/model/dispatch.model';

//Service
import { DispatchService } from '../../../services/dispatch.service';
import { LocalDispatchService } from '../../../services/local-dispatch.service';
import { UsersService } from '../../../services/users.service';
import { BookingsService } from '../../bookings/bookings.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { NonComplianceService } from '../../../services/non-compliance.service';
import { FilesService } from './../../../services/files.service';
import { BreachService } from '../../breach/breach.service';
import { FleetService } from 'src/app/services/fleet.service';
import { DriversService } from "src/app/services/drivers.service";
import { ConnoteService } from 'src/app/services/connote.service';
import { DragulaService } from 'ng2-dragula';
import { ComponentsSettingsService} from '../../../services/components_settings.service';

@Component({
  selector: 'app-manifestdetails',
  templateUrl: './manifestdetails.component.html',
  styleUrls: ['./manifestdetails.component.scss', '../../datatable.scss', './../run/dragula.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DispatchService, UsersService, BookingsService, LocalDispatchService, NonComplianceService, FilesService, DragulaService]
})
export class ManifestdetailsComponent implements OnInit {

  @ViewChild('modalNote', { static: false }) modalNote: TemplateRef<any>;
  @ViewChild('modalDeleteNote', { static: false }) modalDeleteNote: TemplateRef<any>;
  @ViewChild('modalGenerate', { static: false }) modalGenerate: TemplateRef<any>;
  @ViewChild('modalEditActivity', { static: false }) modalEditActivity: TemplateRef<any>;
  @ViewChild('modalRelease', { static: false }) modalRelease: TemplateRef<any>;
  @ViewChild('modalCollect', { static: false }) modalCollect: TemplateRef<any>;
  @ViewChild('modalRunsheet', { static: false }) modalRunsheet: TemplateRef<any>;
  @ViewChild('modalActivityInfo', { static: false }) modalActivityInfo: TemplateRef<any>;
  @ViewChild('modalDeallocate', { static: false }) modalDeallocate: TemplateRef<any>; //deallocate connotes
  @ViewChild('openModalEditJob', { static: false }) openModalEditJob: TemplateRef<any>;
  @ViewChild('modalAddTask', { static: false }) modalAddTask: TemplateRef<any>;
  @ViewChild('modalAddTaskFromPool', { static: false }) modalAddTaskFromPool: TemplateRef<any>;

  @LocalStorage() url!: Url;
  @LocalStorage() user: User;
  @LocalStorage() themeSettings: ThemeSetting;
  public fileStoragePath = this.url.fileStorage;

  public loadingIndicator: boolean = true;

  public modalRef: NgbModalRef;
  public activityForm: FormGroup;
  public frmNote: FormGroup;
  public frmActivity: FormGroup;
  isEditMode: boolean = false;
  spinner: boolean = false;
  note: RunNote;
  notes = [];
  public sub: Subscription;
  public run_id = null;
  public runData: any;
  plannedTasks: any[] = [];

  public showDetails            : boolean = false;

  public service_types =  []
  public run_actions =    []
  public run_types =      []
  public states =         []
  public routes =         []
  public locations =      []
  public run_statuses =   []
  public phases =         []

  /**
   * Store the general list of the corresponding data
   */
  allDrivers = [];
  allTrucks = [];
  allTrailers = [];
  allTaskPhases = [];
  allAvailableConnotes = [];

  /**
   * Disable the button when clicked
   */
  jobEditDisableBtn: boolean = false;
  jobEditActivityBtn         = null;

  public connotesList = [] //added and used only for dealloc function
  public errorMsg1 = "";
  public errorMsg2 = "";
  public d_ModalLoader: boolean = false;
  public is_UpdateError: boolean = false; //for primary error
  public is_UpdateWarning: boolean = false // secondary error (warning)

  //Documents     
  public connotes = []
  public connote_files = []
  public runsheet_files = []
  public plabel_files = []
  public ppd_files = []
  public pod_files = []
  public pod_pics = []
  public fuels = []
  public d_test = []
  public trk_test = []
  public trl_test = []
  public pickup_docket_file = [];
  public release_docket_file = [];
  public collect_docket_file = [];
  public delivery_docket_file = [];
  public pickup_docket_img = [];
  public delivery_docket_img = [];

  // Compliance Checker
  public compliancePercentage: number = 0;
  public isDriverFitnessChecked: boolean = false;
  public isFleetChecked: boolean = false;
  public isWorkDiarySubmitted: boolean = true;
  public isFatigueRequirementsSubmitted: boolean = false;
  public isLocationChecked: boolean = false;
  public isMassWeightsChecked: boolean = false;
  public isLoadRestraintChecked: boolean = false;
  public isChecklist: boolean = false;
  public hasPickupActivity: boolean = false;

  public flagDriverFitness: boolean = false;

  // Breaches
  public clonedRun: any
  public timeBreaches: any = [];
  public locationBreaches: any = [];
  private ngUnsubscribe = new Subject<void>();
  public members = [];
  public driver: string;
  public checkDateTime: boolean = true;
  public selectedEvent: any = null;
  public mapObj: any;
  public mapLat;
  public mapLng;
  public pointdata: any;
  public userSettings: any = {
    showSearchButton: false,
    inputPlaceholderText: 'Type key word on location to search',
    showCurrentLocation: false
  };
  location_valid: boolean = true;
  release_id: any;
  collect_id: any;
  geometryValue: boolean = true;
  is_multiple_connotes: boolean = false;
  public breachId: number = null;
  public trail: any;
  public actualActs: any;
  public playtBtn: boolean = true;
  private markerInterval: any;
  public btnStatuses: boolean[] = [];
  public btnDisable: boolean[] = [];
  //Map
  public mapZoom = 4;
  public centerLat = -27.9241217;
  public centerLng = 135.8894536;
  public positions: any[] = [];
  public geofencePositions: any[];
  public geofences: any[] = [];
  public driverInfo: any;
  public geofenceInfo: any;
  private _runAction$ = new ReplaySubject<RunAction[]>(1);
  private _runData$ = new BehaviorSubject<any>(null);

  //Firebase collection
  public firebaseLogs: any[] = [];


  //Volvo
  public volvo = [];
  public volvo_loadingIndicator: boolean = false;
  volvo_result = null;
  volvo_message = null;
  volvo_connect = false;
  public volvo_page: any;

  //NCR
  public NCR: NonCompliance;
  public NCRForm: FormGroup;
  ncr_categories = [];
  ncr_codes = [];
  ncr_classification = [];
  ncr_status = [];

  public fileExists: boolean;
  public oldFile: string;
  public frmFile: any;
  public fileRemove: boolean;
  public readonly prefixNCR = 'ncr';
  is_image: boolean = true;
  isEditModeNCR: boolean = false;
  public objToDelete: any;
  public pushFleetOptions: IMultiSelectOption[];
  public pushFleetModel = [];
  public pushFleetSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-sm btn-secondary btn-block',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true
  };

  public pushFleet: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Find',
    defaultTitle: 'Select Fleet',
    allSelected: 'All selected',
  };

  public pushDriverOptions: IMultiSelectOption[];
  public pushDriverModel = [];
  public pushDriverSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-sm btn-secondary btn-block',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true
  };

  public pushDriver: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Find',
    defaultTitle: 'Select Driver',
    allSelected: 'All selected',
  };
  isDriverSelected: boolean = false;
  dateNow:any;

  @ViewChild('modalNCR', { static: false }) modalNCR: TemplateRef<any>;
  @ViewChild('modalDeleteNCR', { static: false }) modalDeleteNCR: TemplateRef<any>;
  @ViewChild('modalDeleteBreachLocation', { static: false }) modalDeleteBreachLocation: TemplateRef<any>;

  constructor(private _Activatedroute: ActivatedRoute,
    private dispatchService: DispatchService,
    private localDispatchService: LocalDispatchService,
    private memberService: UsersService,
    private toastr: ToastrService,
    private _fb: FormBuilder,
    private _modal: NgbModal,
    public router: Router,
    private bookingsService: BookingsService,
    private firestore: AngularFirestore,
    private ncrService: NonComplianceService,
    private fileService: FilesService,
    private breachService: BreachService,
    private fleetService: FleetService,
    private driversService: DriversService,
    private connoteService: ConnoteService,
    private dragulaService: DragulaService,
    private svc_components : ComponentsSettingsService
  ) { 
    this.dragulaService.createGroup('PHASE_TASK', {

    });

    this.dragulaService.drop("PHASE_TASK").subscribe(args => {
      if(this.runData.run_type_id != 1) this.editorSetRoute();
    });
  }

  ngOnInit(): void {
    this.dateNow = new Date().toLocaleString();
    this.loadingIndicator = true
    console.time('retrieving Dispatch info');
    this.sub = this._Activatedroute.params.subscribe(params => {
      this.run_id = params["id"];
    });
    this.getData();
    this.getRun();
    this.getMembers();
    this.initForm();
    this.getDispatchNotes();
    this.processManifestBreach();
    this.initJobEditForm();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  public viewConnote(control_no) {
    if(this.isEnabled('Connotes') || this.isEnabled('Jobs')){
      let row = this.connotes.find(x => x.control_no == control_no)
      const openIn = this.router.serializeUrl(
        this.router.createUrlTree(['bookings/connotes/details/', row.id])
      );
      window.open(openIn, '_blank');
    }
  }

  public viewChangeover(id) {
    const openIn = this.router.serializeUrl(
      this.router.createUrlTree(['dispatch/manifestdetails/', id])
    );
    window.open(openIn, '_blank');
  }

  async getRun() {
    this.d_test = [];
    this.trk_test = [];
    this.trl_test = [];
    this.initNCRForm();
    await this.dispatchService.getRunById(this.run_id).toPromise().then(data => {
      this.runData = data['run'];

      this.getFirestoreDrivercollection(this.runData)
      this.fuels = this.runData.fuels
      this.d_test = this.runData.driver_tests
      this.runData.vehicle_tests.forEach(el => {
        if (el.fleet_type_id == 4) {
          this.trl_test.push(el)
        } else this.trk_test.push(el)
      });
      this.pickup_docket_file = this.runData['pickup_docket'];
      this.release_docket_file = this.runData['release_docket'];
      this.collect_docket_file = this.runData['collect_docket'];
      this.delivery_docket_file = this.runData['delivery_docket'];
      this.pickup_docket_img = this.runData['pickup_docket_img'];
      this.delivery_docket_img = this.runData['delivery_docket_img'];
      this.driver = this.runData['driver'];
      this.driver = this.driver['full_name'];
      if (this.runData.total_work_hours > 0) {
        let temp = (Number(this.runData.total_work_hours) + Number(this.runData.min_long_rest_hours) +
          Number(this.runData.min_short_rest_hours) + Number(this.runData.other_rest_hours)).toFixed(2);
        let string_hrs = (temp.toString()).split(".")

        if (string_hrs[1] != '00') {
          this.runData['drv_Hours'] = string_hrs[0] + " hrs " + (Number("." + string_hrs[1]) * 60) + " mins";
        } else this.runData['drv_Hours'] = string_hrs[0] + " hrs ";
      } else this.runData['drv_Hours'] = "0 hrs";

      let test = new Date(this.runData.departure_date + ' ' + this.runData.departure_time);
      this.runData.departure_time = test;
      test = new Date(this.runData.arrival_date + ' ' + this.runData.arrival_time);
      this.runData.arrival_time = test;
      let temp = this.runData.plan_activities;
      this.plannedTasks = this.runData.plan_activities.map(obj=>Object.assign({}, obj));
      temp.forEach(e => { this.connotes.push(e.connote) });

      this.connotes = this.connotes.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)

      // to identify if the run is containing multiple connote.
      if (this.connotes.length > 1) {
        this.is_multiple_connotes = true;
      };

      this.getConnoteDocs();
      // compliance initialization
      this.isDriverFitnessChecked = this.runData['is_driver_fitness_for_duty_checked'];

      this.isFleetChecked = this.runData['is_fleet_checked'];
      this.isWorkDiarySubmitted = this.runData['is_work_diary_submitted'];
      this.isChecklist = this.runData['is_checklist'];
      this.isFatigueRequirementsSubmitted = this.runData['is_fatigue_requirements_checked'];
      this.isLocationChecked = this.runData['is_location_checked'];
      this.isLoadRestraintChecked = this.runData['is_load_restraint_checked'];
      this.isMassWeightsChecked = this.runData['is_mass_weights_checked'];

      this.sortHistory();
      if (this.runData.plan_activities.length > 0) {
        this.runData.plan_activities.forEach(el => {
          if ((el.run_action_id == 3 || el.run_action_id == 4) && el.connote_site_id != null) el['isHidden'] = true; else el['isHidden'] = false;
          let temp = this.runData.actual_activities.find(x => x.run_plan_activity_id == el.id
            && x.run_action_id == el.run_action_id)
          temp != undefined ? el['is_done'] = true : el['is_done'] = false;
        });

        this.phases = [];
        if (this.runData.plan_activities[this.runData.plan_activities.length - 1].phase_order_number == 1) { //more than 1 phase
          this.phases.push(this.runData.plan_activities);
        } else {
          let x = Math.max.apply(Math, this.runData.plan_activities.map(function (o) { return o.phase_order_number; }));
          for (let i = 1; i <= x; i++) {
            let phasecontents = this.runData.plan_activities.filter(x => { return x.phase_order_number == i });
            this.phases.push(phasecontents);
          }
        }
        this.runData.plan_activities = this.phases;
      }

      this.runData.plan_activities.sort((a, b) => {
        return a.order_number - b.order_number;
      });

      if (this.runData.actual_activities.length > 0) {
        if (this.runData.run_status_id == 4 || this.runData.run_status_id == 5) {
          if (this.runData.actual_activities[this.runData.actual_activities.length - 1].run_action_id == 3 ||
            this.runData.actual_activities[this.runData.actual_activities.length - 1].run_action_id == 7) {
            this.runData.plan_activities.forEach(function (item, index, object) {
              if (item.isHidden) { object.splice(index, 1) }
            });
          }
        }
      }

      var res = [];
      this.runData.equipment.forEach(fleet => {
        var fl = { id: fleet.equipment_id, name: fleet.rego };
        res.push(fl);
      })
      this.pushFleetOptions = res;

      var dr_array = [];
      this.runData.driver.forEach(drv=>{
        var dr = {id:drv.driver_id, name: drv.first_name+' '+drv.last_name};
        dr_array.push(dr);
       })

      this.pushDriverOptions = dr_array;
      this.connotesList = this.getConnotesForDeallocate(this.runData['plan_activities']);
      console.timeEnd('retrieving Dispatch info');
      this.clonedRun = cloneRun(this.runData)
      this._runData$.next(this.clonedRun);
    })
    setTimeout(() => { this.loadingIndicator = false; }, 2000);
  }

  //GET SERVICES
  async getData() {
    this.loadingIndicator = true
    await this.dispatchService.getDispatchMiscData().toPromise().then(data => {
      // console.log('misc data', data)
      this.service_types = data['service_types'];
      this.run_actions = data['run_actions'];
      this._runAction$.next(data['run_actions']);
      this.run_types = data['run_types'];
      this.states = data['states'];
      this.routes = sortRoutes(data['state_routes'], data['states']);
      this.locations = data['locations'];
      this.run_statuses = data['run_statuses'];
      this.ncr_categories = data['ncr_categories'];
      this.ncr_codes = data['ncr_code'];
      this.ncr_classification = data['ncr_classification'];
    });
  }

  /**
   * Reformat the list based on allTaskPhases model
   * @param taskArray Contains the planned tasks
   * @returns List of formatted planned tasks
   */
  mapTaskByModel(taskArray: any[]){
    const formattedTasksArray = [];
    
    taskArray.forEach((obj)=>{
      if(obj.location != undefined){
        formattedTasksArray.push({
          "id": obj.id,
          "run_id": obj.run_id,
          "connote_id": obj.connote_id,
          "connote_site_id": obj.connote_site_id,
          "prev_run_id": obj.prev_run_id,
          "run_action_id": obj.run_action_id,
          "order_number": obj.order_number,
          "phase_order_number": obj.phase_order_number,
          "location_id": obj.location_id,
          "start_datetime": obj.start_datetime,
          "end_datetime": obj.end_datetime,
          "created_by": obj.created_by,
          "updated_by": obj.updated_by,
          "admin_override": obj.admin_override,
          "created_at": obj.created_at,
          "updated_at": obj.updated_at,
          "connote":{
              "id": obj.connote?.id,
              "control_no": obj.connote?.control_no,
              "run_status_id": obj.connote?.run_status_id,
              "customer_reference_no": obj.connote?.customer_reference_no,
              "company_name": obj.connote?.customer?.company_name, // get it in `customer` of `connote` object
              "run_type_id": obj.connote?.run_type_id, // get it in `connote`
              "service_type_id": obj.connote?.service_type_id,
              "connote_documents": [] // might be in `run` object but leave it blank atm
          },
          "connote_control_no": obj.connote?.control_no, // get it in `connote` object
          "customer_reference_no":  obj.connote?.customer_reference_no, // get it in `connote` object
          "customer_name": obj.connote?.customer?.company_name, // get it in `company_name` of `connote` object
          "company_name": obj.connote_site?.company_name, // referring to the connote_sites' field
          "street_no": obj.location?.street_no, // get it in `location` object
          "city": obj.location?.city, // get it in `location` object
          "suburb": obj.location?.suburb, // get it in `location` object
          "postal_code": obj.location?.postal_code, // get it in `location` object
          "state_id": obj.location?.state_id, // get it in `location `object
          "state_abbrev": obj.location?.state?.abbreviation, // get it in `state` object of `location` object
          "lat": obj.location?.lat, // get it in `location` object
          "lng": obj.location?.lng, // get it in `location` object
          "connote_contact_name": obj.connote_site?.contact_name, // get it in `connote_site` object 
          "connote_contact_no": obj.connote_site?.contact_no, // get it in `connote_site` object 
          "connote_contact_email": obj.connote_site?.contact_email, // get it in `connote_site` object 
          "connote_notes": obj.connote_site?.notes, // get it in `connote_site` object 
          "rp_done": false, // default is false for 
          "start_datetime_utc": obj.start_datetime_utc,
          "end_datetime_utc": obj.end_datetime_utc,
          "isHidden": false, // default is false for history
          "is_done": false // default is false 
        })
      }else{
        formattedTasksArray.push(obj);
      }
    });

    return formattedTasksArray;
  }


  /**
   * Merge the selected tasks to the original list of tasks
   * @param originalArray Contains the list of original planned tasks
   * @param selectedTasks Contains the list of selected planned tasks
   */
  mergePlannedTasks(originalArray, selectedTasks){
    let origin = originalArray;
    let existingIds = new Set();
    existingIds = this.getExistingIds(origin, existingIds);
    
    let remainingObjs = [];
    // check if any objects in originalArray are missing from selectedTasks
    [existingIds, remainingObjs] = this.getRemainingObjects(selectedTasks, existingIds, remainingObjs);
    
    originalArray = this.removeMatchedObjects(origin, existingIds);

    // If there are remaining objects in remainingObjs, add it to the end of originalArray with these objects
    if (remainingObjs.length > 0) {
      originalArray[originalArray.length-1].push(...remainingObjs);
    }
  }
  
  /**
   * Get the IDs only from an array of array list
   * @param originalArray Contains an array of array
   * @param selectedArray Contains the planned tasks
   * @returns An object of IDs
   */
  getExistingIds(originalArray, existingIds){
    for (let i = 0; i < originalArray.length; i++) {
      for (let j = 0; j < originalArray[i].length; j++) {
        existingIds.add(originalArray[i][j].id);
      }
    }
    return existingIds;
  }

  /**
   * Iterate through selectedArray and add unmatched objects to the remainingObjs array
   * @param selectedArray Contains the list of plannedTasks
   * @param existingIds Contains an object of IDs
   * @param remainingObjs Contains the list of unmatched items compared with allTaskPhases and plannedTasks
   * @returns the remaining IDs and objects
   */
  getRemainingObjects(selectedArray, existingIds, remainingObjs){
    for (let i = 0; i < selectedArray.length; i++) {
      if (!existingIds.has(selectedArray[i].id)) {
        remainingObjs.push(selectedArray[i]);
        this.removeFromTaskDelete(selectedArray[i].id);
      } else {
        existingIds.delete(selectedArray[i].id);
      }
    }
    return [existingIds, remainingObjs];
  }

  /**
   * Remove any matched objects from originalArray
   * @param originalArray Contains the list of allTaskPhases
   * @param existingIds Contains the remaining IDs not existing in allTaskPhases
   * @returns 
   */
  removeMatchedObjects(originalArray, existingIds){
    for (let i = 0; i < originalArray.length; i++) {
      for (let j = 0; j < originalArray[i].length; j++) {
        if (existingIds.has(originalArray[i][j].id)) {
          originalArray[i].splice(j, 1);
          j--;
        }
      }
    }
    return originalArray;
  }

  /**
   * If task is returned to list from task pool, we remove them in the task_delete array (if exists)
   * @param id run_plan_activity_id of the task
   */
  removeFromTaskDelete(id){
    const editForm = this.frmJobEditForm.get('task_delete') as FormArray;
    if(editForm.value.includes(id)){
      editForm.value.splice(editForm.value.findIndex(x=>x==id), 1)
    }
  }


  public getConnoteDocs() {
    this.connote_files = [];
    this.plabel_files = [];
    this.ppd_files = [];
    this.runsheet_files = [];
    this.pod_files = [];

    this.connotes.forEach(con => {
      if (con.connote_documents.length != 0) {
        con.connote_documents.forEach(docs => {
          switch (docs.connote_document_type_id) {
            case 15: {
              this.plabel_files.push(docs); break;
            }
            case 13: {
              this.runsheet_files.push(docs); break;
            }
            case 12: {
              this.ppd_files.push(docs); break;
            } case 9: {
              this.connote_files.push(docs); break;
            } case 1: {
              this.pod_files.push(docs); break;
            } default: {
              break;
            }
          }
        });
      }
    });

    // Include display of runsheet from runs table
    if (this.runData.runsheet_file != null) {
      this.runsheet_files.push(this.runData.runsheet_file);
    }

  }
  public compareDates(startDate, endDate) {
    let formattedStartDate = formatDate(startDate, 'yyy-MM-dd', 'en_US');
    let formattedEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en_US');

    return formattedStartDate < formattedEndDate;
  }

  applyComplianceBarStyles() {
    let percentage = 0;

    if (this.runData.run_type_id == 1) { // for Local Job's compliance
      percentage = ((Number(this.isDriverFitnessChecked) +
        Number(this.isFleetChecked) +
        Number(this.isLocationChecked)
      ) / 3) * 100;
    } else if (this.runData.run_type_id == 3) { // for Empty Run Job's compliance
      percentage = ((Number(this.isDriverFitnessChecked) +
        Number(this.isFleetChecked) +
        Number(this.isMassWeightsChecked) +
        Number(this.isWorkDiarySubmitted) +
        Number(this.isLocationChecked) +
        Number(this.isFatigueRequirementsSubmitted)
      ) / 6) * 100;
    } else if (this.runData.run_type_id == 6) { // for PUD Job's compliance
      let hasPickup;

      this.runData.plan_activities.forEach(element => {
         element.find(data => {
          if(data.run_action_id == 1) return hasPickup =  true;

        });
      });

      if (hasPickup != undefined) {
        this.hasPickupActivity = true;
        percentage = ((Number(this.isDriverFitnessChecked) +
          Number(this.isFleetChecked) +
          Number(this.isLoadRestraintChecked) +
          Number(this.isLocationChecked)
        ) / 4) * 100;
      } else {
        this.hasPickupActivity = false;
        percentage = ((Number(this.isDriverFitnessChecked) +
          Number(this.isFleetChecked) +
          Number(this.isLocationChecked)
        ) / 3) * 100;
      }
    } else {                                  // for Linehaul and Towhaul Job's compliance
      this.hasPickupActivity = true;
      percentage = ((Number(this.isDriverFitnessChecked) +
        Number(this.isFleetChecked) +
        Number(this.isMassWeightsChecked) +
        Number(this.isLoadRestraintChecked) +
        Number(this.isWorkDiarySubmitted) +
        Number(this.isLocationChecked) +
        Number(this.isFatigueRequirementsSubmitted)
      ) / 7) * 100;
    }

    this.compliancePercentage = percentage;
    if (percentage == 0) percentage = 100;
    var p = percentage.toString() + '%';
    const styles = { 'width': p };
    return styles;
  }

  public onChangeChecklist() {

    this.dispatchService.manifestToggleChecklist(this.isChecklist, this.runData.id, this.user.id).subscribe(data => {
      if (this.isChecklist) {
        this.toastr.success('', 'Compliance Checklist checked to do manual compliance checking.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      else {
        this.toastr.info('', 'Compliance Checklist returned to automated compliance checking.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      this.getRun();
    }, err => {
      this.toastr.error("There was a problem with updating the selected compliance checklist compliance status. Please try again.", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
  }

  public onChangeDriverFitnessChecked() {
    this.dispatchService.manifestToggleDriverFitnessCompliance(this.isDriverFitnessChecked, this.runData.id).subscribe(data => {
      // this.isDriverFitnessChecked = data.flag;

      if (this.isDriverFitnessChecked) {
        this.toastr.success('', 'Driver Fitness checks are successfully marked as compliant.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      else {
        this.toastr.info('', 'Driver fitness checks has been successfully marked as non-compliant.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }

    }, err => {
      this.toastr.error("There was a problem with updating the selected driver fitness compliance status. Please try again.", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
  }

  public onChangeFleetChecked() {
    this.dispatchService.manifestToggleFleetCheckCompliance(this.isFleetChecked, this.runData.id).subscribe(data => {
      if (this.isFleetChecked) {
        this.toastr.success('', 'Fleet checks have passed compliance.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      else {
        this.toastr.info('', 'Fleet checks is currently incomplete.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
    }, err => {
      this.toastr.error("There was a problem with updating the selected fleet check compliance status. Please try again.", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
  }

  public onChangeMassWeightsChecked() {
    this.dispatchService.manifestToggleMassWeightCheckCompliance(this.isMassWeightsChecked, this.runData.id).subscribe(data => {
      if (this.isMassWeightsChecked) {
        this.toastr.success('', 'Mass weights are now marked as successfully checked.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      else {
        this.toastr.info('', 'Mass weights has been marked as Not Compliant.', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
    }, err => {
      this.toastr.error("There was a problem with updating the selected mass weights check compliance status. Please try again.", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
  }

  public onChangeWorkDiarySubmitted() {
    this.dispatchService.manifestToggleWorkDiaryCompliance(this.isWorkDiarySubmitted, this.runData.id).subscribe(data => {
      if (this.isWorkDiarySubmitted) {
        this.toastr.success('', 'Work Diary is now marked as submitted', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      else {
        this.toastr.warning('', 'Work Diary is marked as Not Submitted', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
    }, err => {
      this.toastr.error("There was a problem with updating the selected work diary compliance status. Please try again", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
  }

  public onChangeFatigueRequirementsSubmitted() {
    this.dispatchService.manifestToggleFatigueRequirementCompliance(this.isFatigueRequirementsSubmitted, this.runData.id).subscribe(data => {
      if (this.isFatigueRequirementsSubmitted) {
        this.toastr.success('', 'Fatigue Requirements is now marked as submitted', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      else {
        this.toastr.warning('', 'Fatigue Requirements is marked as Not Submitted', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
    }, err => {
      this.toastr.error("There was a problem with updating the selected fatigue requirement compliance status. Please try again", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
  }

  public onChangeLocationChecked() {
    this.dispatchService.manifestToggleLocationCheckCompliance(this.isLocationChecked, this.runData.id).subscribe(data => {
      if (this.isLocationChecked) {
        this.toastr.success('', 'Location Checks is now marked as compliant', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      else {
        this.toastr.warning('', 'Location checks is marked as Non-compliant', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }

    }, err => {
      this.toastr.error("There was a problem with updating the selected location check compliance status. Please try again", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
  }

  public onChangeLoadRestraintChecked() {
    this.dispatchService.manifestToggleLoadRestraintCheckCompliance(this.isLoadRestraintChecked, this.runData.id).subscribe(data => {
      if (this.isLoadRestraintChecked) {
        this.toastr.success('', 'Load Restraints are now marked as successfully checked', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
      else {
        this.toastr.warning('', 'Load Restraints has been marked as Not Compliant', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
    }, err => {
      this.toastr.error("There was a problem with updating the selected load restraint check compliance status. Please try again", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
  }

  public getMembers() {
    this.memberService.getMembers().subscribe(data => {
      this.members = data['members'];
    })
  }

  public processManifestBreach() {
    combineLatest([
      this.breachService.getRunPlanBreaches(this.run_id),
      this.breachService.getRunEventBreaches(this.run_id),
      this._runAction$,
      this._runData$
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next:([runplanBreaches, runeventBreaches, runActions, Run]) => {
          console.warn("runplanBreaches",runplanBreaches)
          let Breaches: BreachRequest[] = []
          this.locationBreaches = []
          this.timeBreaches = []
  
          Breaches.push(...runplanBreaches, ...runeventBreaches)
  
          if (Run && Breaches.length > 0) {
            Run.driver.forEach((driver) => {
              let timeBreach: BreachRequest[] = Breaches.filter((breach) => breach.breach_type_id == 'time' && breach.requested_by.id == driver.user_id)
              if (timeBreach.length > 0) {
                this.timeBreaches.push(...timeBreach)
                this.timeBreaches = sortBreaches(this.timeBreaches)
              }
              let locationBreach: BreachRequest[] = [] = Breaches.filter((breach) => breach.breach_type_id == 'location' && breach.requested_by.id == driver.user_id)
              if (locationBreach.length > 0) {
                this.locationBreaches.push(...locationBreach)
                this.locationBreaches = sortBreaches(this.locationBreaches)
                this.disableBtn(this.locationBreaches)
                this.processBreachinfo(this.locationBreaches, Run.plan_activities, runActions)
              }
            })
          }
        },
        error:()=>{
          this.toastr.error("Please refresh the page.", "There was a problem with loading the breach requests", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }
      })
  }

  disableBtn(locationBreches: BreachRequest[]) {
    locationBreches.forEach((breach, index) => {
      this.btnDisable[index] = true;
    })
  }

  processBreachinfo(breachInfo: BreachRequest[], runPlanActivity: any[], runActions: RunAction[]) {
    if (breachInfo?.length > 0 && runPlanActivity.length > 0 && runActions?.length > 0) {
      let markerPoints = []
      let geofenceCircles = []
      let runplanAct = runPlanActivity
      breachInfo.forEach((breach) => {
        const runActionlable = runActions.find((action) => action.id == breach.run_plan_activity.run_action_id)
        const runPlan = runplanAct.find((act) => act.id == breach.run_plan_activity.id)
        if (breach.breachable.latitude && breach.breachable.longitude && runPlan && runActionlable) {
          const moldMarker = {
            driverName: breach.requested_by.display_name,
            runActionlabel: runActionlable.label.toUpperCase(),
            controlNumber: runPlan.connote_control_no,
            lat: parseFloat(breach.breachable.latitude),
            lng: parseFloat(breach.breachable.longitude),
            breachtimestamp: breach.breachable.created_at,
            address: breach.breachable.address,
            plannedLocation: `${breach.run_plan_activity.location.street ?? ''} ${breach.run_plan_activity.location.street_no ?? ''} ${breach.run_plan_activity.location.short_text ?? ''}`
          }
          const moldGeofence = {
            radius: breach.run_plan_activity.geofence.radius,
            lat: parseFloat(breach.run_plan_activity.location.lat),
            lng: parseFloat(breach.run_plan_activity.location.lng),
            runActionlabel: moldMarker.runActionlabel,
            controlNumber: moldMarker.controlNumber,
            plannedLocation: moldMarker.plannedLocation
          }
          markerPoints.push(moldMarker)
          geofenceCircles.push(moldGeofence)
        }
      })
      this.getCurrentLocations(markerPoints, geofenceCircles)
    }
  }

  getCurrentLocations(marker: any[], geofences: any[]) {
    let mapMarkers = []
    let mapGeofences = []
    mapMarkers.push(...marker)
    mapGeofences.push(...geofences)
    this.positions = mapMarkers
    this.geofences = mapGeofences
    this.mapZoom = 4
  }

  playLocationHistory(actID: number, ind: number) {
    this.btnStatuses[ind] = true
    this.btnDisable.forEach((status, index, array) => {
      if (index !== ind) {
        array[index] = false
      }
    })
    const runplanAct = this.actualActs.find((act) => act.run_plan_activity_id == actID)
    const result = this.firebaseLogs.filter((rec) => (new Date(runplanAct.start_utc).getTime() >= rec.number_timestamp) || (new Date(runplanAct.end_utc).getTime() <= rec.number_timestamp))
    let index = 0
    this.markerInterval = setInterval(() => {
      this.mapZoom = 0;
      if (index > (result.length - 1)) {
        index = 0
        this.btnStatuses[ind] = false
        this.btnDisable.forEach((status, index, array) => {
          if (index !== ind) {
            array[index] = true
          }
        })
        this.trail = null
        clearInterval(this.markerInterval)
      } else {
        const mold = {
          lat: result[index].lat,
          lng: result[index].lng
        }
        this.centerLat = mold.lat
        this.centerLng = mold.lng
        this.mapZoom = 15;
        this.trail = mold
        index = index + 1
      }
    }, 3400)
  }

  stopLocationHistory(ind: number) {
    this.btnStatuses[ind] = false
    this.trail = null
    clearInterval(this.markerInterval)
  }

  clickMarker({ target: marker }, driver) {
    this.driverInfo = null
    this.driverInfo = {
      display: true,
      displayGeofence: false,
      driverName: driver.driverName,
      lat: driver.lat,
      lng: driver.lng,
      address: driver.address,
      breachtimestamp: driver.breachtimestamp,
      controlNumber: driver.controlNumber,
      runActionlabel: driver.runActionlabel,
      plannedLocation: driver.plannedLocation
    }
    marker.nguiMapComponent.openInfoWindow('iwd', marker);
  }

  clickGeofence({ target: circle }, geofence) {
    this.geofenceInfo = null
    this.geofenceInfo = {
      display: true,
      radius: geofence.radius,
      plannedLat: geofence.lat,
      plannedLng: geofence.lng,
      runActionlabel: geofence.runActionlabel,
      plannedLocation: geofence.plannedLocation,
      controlNumber: geofence.controlNumber,
    }
    circle.nguiMapComponent.openInfoWindow('iwg', circle);
  }

  onSelect(selected) {
    this.mapZoom = 0;
    let lat = selected.breachable.latitude ?? null
    let lng = selected.breachable.longitude ?? null
    if (lat && lng) {
      this.centerLat = parseFloat(lat);
      this.centerLng = parseFloat(lng);
      this.mapZoom = 15;
    } else {
      this.mapZoom = 15;
    }

  }

  async getFirestoreDrivercollection(Run: any,) {
    this.firebaseLogs = []
    let actualActivities = []
    const runPlanactivities = Run.plan_activities
    const runPlanActual = Run.actual_activities
    runPlanactivities.forEach((planActs) => {
      let actualActivity = null
      actualActivity = runPlanActual.find((actualAct) => actualAct.run_action_id == planActs.run_action_id)
      actualActivities.push(actualActivity)
    })
    const driverId = Run.driver[0].driver_id
    let driverRef: any;
    let queryRef: any;
    for (let act of actualActivities) {
      let companyCode = environment.companyCode
      if (act) {
        driverRef = this.firestore.collection('Drivers').ref;
        queryRef = await driverRef
          .where('driver_id', '==', driverId)
          .where('company_code', '==', companyCode.toLowerCase())
          .orderBy('number_timestamp')
          .startAt(new Date(act.start_utc).getTime())
          .endAt(new Date(act.end_utc).getTime())
          .get();
        const collection = (await queryRef).docs.map(doc => doc.data());
        this.firebaseLogs.push(...collection)
      }
    }
    this.actualActs = actualActivities
  }

  // Notes
  public initForm() {
    this.frmNote = this._fb.group({
      id: [''],
      updated_by: [''],
      run_id: [this.run_id],
      user_id: [this.user.id],
      text: ['', Validators.required]
    });
  }

  // Activities
  public initActForm() {
    let today: Date = new Date();
    let time = { hour: today.getHours(), minute: today.getMinutes() };
    let new_date = today.toISOString().substring(0, 10);

    this.frmActivity = this._fb.group({
      id: [''],
      created_by: [this.user.id],
      updated_by: [this.user.id],
      start_date: [new_date],
      startdate_time: [time],
      enddate_time: [time],
      end_date: [new_date],
      lat: [''],
      lng: [''],
      location_string: [''],
      city: [''],
      suburb: [''],
      street_no: [''],
      street: [''],
      state: [''],
      postal_code: [''],
      
      is_tba: [false],
      connote: [''],
      connote_site_id: [''],
      location_id: [null],
      run_action_id: ['']
    });
  }

  async getDispatchNotes() {
    await this.dispatchService.getDispatchNotes(this.run_id).toPromise().then(data => {
      if (data['notes'].length > 0) {
        this.notes = data['notes'];
      }
      else {
        this.notes = [];
      }
    });
    // setTimeout(() => { this.loadingIndicator = false; }, 500);

  }

  public createDispatchNote(note: RunNote) {
    this.dispatchService.createDispatchNote(note).subscribe(() => {

    });
  }

  public updateDispatchNote(note: any) {
    this.dispatchService.updateDispatchNote(note).subscribe(data => {
      this.toastr.success('', data['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
      this.getDispatchNotes();
    }, err => {
      this.toastr.error("Please try again.", "There was a problem with updating the selected note", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    console.log('Dispatch Note Updated.');
  }

  async deleteDispatchNote(id: number) {
    this.spinner = true;
    await this.dispatchService.deleteDispatchNote(id).toPromise().then(data => {
      this.toastr.success('', data['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }, err => {
      this.toastr.error("Please try again.", "There was a problem with deleting the selected note", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    this.initForm();
    this.getDispatchNotes();
    this.closeModal();
    this.spinner = false;
  }


  openModalNote(note: RunNote): void {
    this.initForm();
    if (note) {
      this.isEditMode = true;
      this.frmNote.controls.id.setValue(note.id);
      this.frmNote.controls.text.setValue(note.text);
      this.frmNote.controls.updated_by.setValue(note.updated_by);

    } else {
      this.isEditMode = false;
      this.frmNote.controls.id.setValue(null);
    };
    this.modalRef = this._modal.open(this.modalNote, { backdrop: 'static' });
  }

  async openModalEditJobs(): Promise<void> {
    console.log('[Manifest Details Edit Mode]')
    this.jobEditDisableBtn = true;
    this.spinner = false;
    this. resetEditVariables();
    this.allTaskPhases = clonePlannedTasks(this.runData.plan_activities);
    this.removeTaskFromPool();
    
    this.frmJobEditForm.controls.run_route.setValue(this.runData.run_routes_id);
    
    await this.fetchAllResources().toPromise().then(check =>{
      this.driverSelectOption = this.allDrivers;
      this.driverSelectOption = this.setMultipleOptions(this.driverSelectOption, this.JOB_EDIT_TYPE.DRIVER);
      this.truckSelectOption = this.allTrucks;
      this.truckSelectOption = this.setMultipleOptions(this.truckSelectOption, this.JOB_EDIT_TYPE.TRUCK);
      this.trailerSelectOption = this.allTrailers;
      this.trailerSelectOption = this.setMultipleOptions(this.trailerSelectOption, this.JOB_EDIT_TYPE.TRAILER);

      this.patchDispatchedData(this.runData['driver'], this.JOB_EDIT_TYPE.DRIVER);
      let dispatchedTruck = this.runData.equipment.filter(fleet => fleet.is_truck == 1);
      this.patchDispatchedData(dispatchedTruck, this.JOB_EDIT_TYPE.TRUCK);
      let dispatchedTrailer = this.runData.equipment.filter(fleet => fleet.is_trailer == 1);
      this.patchDispatchedData(dispatchedTrailer, this.JOB_EDIT_TYPE.TRAILER);

      this.jobEditDisableBtn = false;
    })
    this.modalRef = this._modal.open(this.openModalEditJob, {size: 'lg', backdrop: 'static', centered :true});
  }
  
  /**
   * Re-Initializes arrays to empty
  */
 private resetEditVariables(){
    this.initJobEditForm()
    this.allDrivers = [];
    this.allTrucks = [];
    this.allTrailers = [];
    this.allTaskPhases = [];
    this.allAvailableConnotes = [];
  }

  fetchAllResources(){
    console.log('fetching resources for edit mode...');
    console.time('Retrieve Lists');
    return combineLatest([
      this.driversService.getDrivers().pipe(pluck('drivers')),
      this.fleetService.getFleets2({
        per_page: '-1',
       include : 'type,subtype'
     }).pipe(pluck('data')),
     this.connoteService.getConnotes({
      include: ['customer'],
      filters: new Map([
        ['run_status_id', [1, 2, 3]]
      ]),
      per_page: -1
    })

   ]).map(([drivers, fleet, connotes])=>{
     const { trucks, trailers } = segregateFleetsByType(fleet)
     this.allDrivers = drivers;
     this.allTrucks = trucks;
     this.allTrailers = trailers;
     this.allAvailableConnotes = connotes;
     
     console.timeEnd('Retrieve Lists');
     return [drivers, trucks, trailers, connotes]
   });  
 }

  openModalDeleteNote(note: RunNote): void {
    if (note) {
      this.note = note;
    }
    this.modalRef = this._modal.open(this.modalDeleteNote, { size: 'sm', backdrop: 'static' });
  }

  onSubmitNote(note: RunNote): void {
    this.note = note;

    if (this.frmNote.valid) {
      this.note = note;

      if (note.id) {
        this.note.updated_by = JSON.parse(localStorage.getItem('ngx_user')).id;
        this.updateDispatchNote(this.note);
      }
      else {
        this.dispatchService.createDispatchNote(note).subscribe(data => {
          this.toastr.success('', data['result'], {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
          this.getDispatchNotes();

        }, err => {
          this.toastr.error("Please try again.", "There was a problem with creating new note", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
      }
      this.closeModal();
    }
  }

  async onDeleteNote(id: number) {
    this.spinner = true;
    await this.dispatchService.deleteDispatchNote(id).toPromise().then(data => {
      this.toastr.success('', data['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }, err => {
      this.toastr.error("Please try again.", "There was a problem with deleting the selected note", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    this.initForm();
    this.getDispatchNotes();
    this.closeModal();
    this.spinner = false;
  }

  public closeModal() {
    this.modalRef.close();
    this.initNCRForm();
    this.pushFleetModel = [];
    this.pushDriverModel = [];
  }

  public sortHistory() {
    this.runData.history.sort((a, b) => {
      return new Date(a.created_at).valueOf() - new Date(b.created_at).valueOf();
    });
  }

  public openGenerateSDPModal() {
    this.modalRef = this._modal.open(this.modalGenerate, { size: 'xs', backdrop: 'static' });
  }

  public editTaskModal(phase, index){
    this.initActForm();
    this.jobEditActivityBtn = [phase, index];
    let formdata = this.allTaskPhases[phase][index];
    let d: Date = new Date(formdata.start_datetime);
    let d2: Date = new Date(formdata.end_datetime);

    for(var i=1 ;i<=4;i++){
      var quarter_min = Math.ceil((d.getMinutes() / 15)) *15 +(i*15);
      var quarter_min2 = Math.ceil((d2.getMinutes() / 15)) *15 +(i*15);
      var d_time = new Date(d.getTime() + (quarter_min - d.getMinutes()) *60000);
      var d_time2 = new Date(d2.getTime() + (quarter_min2 - d2.getMinutes()) *60000);
    }

    var hours = (d_time.getHours()%24) -1; var hoursb = (d_time2.getHours()%24) -1;
    var minutes = d_time.getMinutes(); var minutesb = d_time2.getMinutes();
    if (hours == -1) hours = 11; if (hoursb == -1) hoursb = 11;

    this.frmActivity.patchValue(formdata);
    this.frmActivity.get('state').setValue(formdata.state_abbrev);
    this.frmActivity.get('start_date').setValue(d.toISOString().substring(0, 10));
    this.frmActivity.get('end_date').setValue(d2.toISOString().substring(0, 10));
    this.frmActivity.get('startdate_time').setValue({hour: hours , minute: minutes});
    this.frmActivity.get('enddate_time').setValue( {hour: hoursb , minute: minutesb});

    this.modalRef = this._modal.open(this.modalAddTask, { size: 'lg', backdrop: 'static', centered: true });
  }


  public addTaskModal(type){
    this.initActForm();
    this.showDetails = false;
    if(type == 'taskform'){
      this.jobEditActivityBtn = null;
      this.modalRef = this._modal.open(this.modalAddTask, { size: 'lg', backdrop: 'static', centered: true });
    } else if (type="taskpool") { 
      this._modal.open(this.modalAddTaskFromPool, { 
        size: 'lg', 
        backdrop: 'static', centered: true 
      })
      .result
      .then((selected: RunPlanActivity[]) => {
        // Assign the tasks to apply checked mark from the pool
        this.plannedTasks = selected;
        const formattedTask = this.mapTaskByModel(this.plannedTasks);
        this.mergePlannedTasks(this.allTaskPhases, formattedTask);
        this.editorSetRoute();
      })
      .catch(error => {
        console.log("Error caught in Exception.", error);
      });
    }
  }

  public async openEditActivityModal(id,action){
    this.initActForm();
    if(action == 'actual'){
    this.selectedEvent = this.runData.actual_activities.find(x=> x.id == id);

    if (this.selectedEvent.location_id) {
      if (this.selectedEvent.state_id != 0 && this.selectedEvent.state_id != null) {
        let state = this.states.find(x => x.id == this.selectedEvent.state_id).abbreviation;
        this.selectedEvent['state'] = state;
      } else {
        this.selectedEvent['state'] = null
      }
    }

    //check location validity
    if (this.selectedEvent.lat && this.selectedEvent.lng && this.selectedEvent.state_id && this.selectedEvent.suburb
      && this.selectedEvent.postal_code) {
      this.location_valid = true;
    } else this.location_valid = false;

    let d = new Date(this.selectedEvent.start.replace(/-/g, '/'));
    let d2 = new Date(this.selectedEvent.end.replace(/-/g, '/'));

    let new_date = d.toISOString().substring(0, 10);
    let new_date2 = d2.toISOString().substring(0, 10);

    // for(var i=1 ;i<=4;i++)
    // {
    //     var quarter_min = Math.ceil((d.getMinutes() / 15)) *15 +(i*15);
    //     var d_time = new Date(d.getTime() + (quarter_min - d.getMinutes()) *60000);
    //     var d_time2 = new Date(d2.getTime() + (quarter_min - d.getMinutes()) *60000);
    // }
    // var hours = (d_time.getHours()%24) -1; var hoursb = (d_time2.getHours()%24) -1;
    // var minutes = d_time.getMinutes(); var minutesb = d_time2.getMinutes();
    // if (hours == -1) hours = 11; if (hoursb == -1) hoursb = 11;


    //start date time
    let start_time = { hour: d.getHours(), minute: d.getMinutes() };
    let end_time = { hour: d2.getHours(), minute: d2.getMinutes() };

    this.selectedEvent['start_date'] = new_date
    this.selectedEvent['startdate_time'] = start_time
    this.selectedEvent['end_date'] = new_date2
    this.selectedEvent['enddate_time'] = end_time
    this.selectedEvent['action'] = action;
  }
  else{
    this.selectedEvent = id;
    if(this.selectedEvent.location_id){
      if(this.selectedEvent.state_id != 0 && this.selectedEvent.state_id != null){
        let state = this.states.find(x=>x.id == this.selectedEvent.state_id).abbreviation;
        this.selectedEvent['state'] = state;
      } else {
        this.selectedEvent['state'] = null
      }
    }

      //check location validity
    if(this.selectedEvent.lat && this.selectedEvent.lng && this.selectedEvent.state_id && this.selectedEvent.suburb 
          && this.selectedEvent.postal_code){
        this.location_valid = true;
    } else this.location_valid = false;


    var start = new Date(this.selectedEvent?.start_datetime)

    var startMonth= '' + (start.getMonth() + 1);
    var startDate= '' + start.getDate();
    if (startMonth.length < 2) {
      startMonth = '0' + startMonth;
    }
    if (startDate.length < 2) {
      startDate= '0' + startDate;
    }

    var end = new Date(this.selectedEvent?.end_datetime)

    var endMonth = '' + (end.getMonth() + 1);
    var endDate =  '' + end.getDate();

    if (endMonth.length < 2) {
      endMonth = '0' + endMonth;
    }
    if (endDate.length < 2) {
      endDate = '0' + endDate;
    }

      //start date time
    let start_time = {hour: start.getHours()  , minute: start.getMinutes()};
    let end_time = {hour: end.getHours()  , minute: end.getMinutes()};

    this.selectedEvent['start_date'] = start.getFullYear()+'-'+startMonth+ '-'+startDate;
    this.selectedEvent['startdate_time'] = start_time;
    this.selectedEvent['end_date'] = end.getFullYear()+'-'+endMonth+ '-'+endDate;
    this.selectedEvent['enddate_time'] = end_time;
    this.selectedEvent['action'] = action;
  }
    this.frmActivity.patchValue(this.selectedEvent);
    this.modalRef = this._modal.open(this.modalEditActivity, { size: 'lg', backdrop: 'static', centered: true });
    this.checkLocation();
  }

  public checkLocation() {
    const formCtrl = <any>this.frmActivity;
    const latCtrl = formCtrl.controls["lat"];
    const longCtrl = formCtrl.controls["lng"];
    const suburbCtrl = formCtrl.controls["suburb"];
    const stateCtrl = formCtrl.controls["state"];
    const postalCodeCtrl = formCtrl.controls["postal_code"];

    //check location validity
    if (latCtrl.value != null && longCtrl.value != null && stateCtrl.value != null && suburbCtrl.value != null && postalCodeCtrl.value != null) {
      this.location_valid = true;
    } else this.location_valid = false;
    return this.location_valid;
  }
  public checkDates() {
    this.location_valid = true;
    this.checkDateTime = false;

    let start = {
      "date": this.frmActivity.get('start_date').value,
      "starttime": this.frmActivity.get('startdate_time').value
    }
    let end = {
      "date": this.frmActivity.get('end_date').value,
      "endtime": this.frmActivity.get('enddate_time').value
    }

    let check_start = new Date(start.date + ' ' + start.starttime.hour + ":" + start.starttime.minute + ":00");
    let check_end = new Date(end.date + ' ' + end.endtime.hour + ":" + end.endtime.minute + ":00");

    (check_start > check_end) ? this.checkDateTime = false : this.checkDateTime = true;


    if (this.frmActivity.get('lat').value && this.frmActivity.get('lng').value && this.frmActivity.get('state').value
      && this.frmActivity.get('suburb').value && this.frmActivity.get('postal_code').value) {
      this.location_valid = true;
    } else this.location_valid = false;
  }

  public checkTaskRequirements() {
    const formCtrl = <any>this.frmActivity;
    const latCtrl = formCtrl.controls["lat"];
    const longCtrl = formCtrl.controls["lng"];
    const suburbCtrl = formCtrl.controls["suburb"];
    const stateCtrl = formCtrl.controls["state"];
    const postalCodeCtrl = formCtrl.controls["postal_code"];
    const tba = formCtrl.controls['is_tba'];

    this.location_valid = false;
    if(!tba.value){
      if (latCtrl.value != '' && longCtrl.value != '' && stateCtrl.value != '' && suburbCtrl.value != '' && postalCodeCtrl.value != '') {
        this.location_valid = true;
      }
    } else this.location_valid = true;

    return this.location_valid && 
           (formCtrl.controls["run_action_id"].value != '' && 
            formCtrl.controls["connote"].value != '');
  }

  async generateSDP() {
    this.spinner = true;
    await this.dispatchService.generateSDP(this.runData.id, this.user.id, 'admin manual generate').toPromise().then(data => {
      if (data['error'] != true) {
        this.toastr.success('', data['message'], {
          timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
        });
        this.getRun();
      } else {
        this.toastr.error('', data['message'], {
          timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
        });
      }
    }, err => {
      this.toastr.error("Please try again.", "There was a problem with deleting the selected note", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    this.spinner = false;
    this.closeModal();
  }

  public formatDate(inDate: string) {
    let formatedDate: Date;
    if (inDate && !inDate.includes('0000')) {
      formatedDate = new Date(inDate.replace(/-/g, '/'));
      return formatedDate;
    }
    else {
      return null;
    }
  }

  public pickupAddressCallback(selectedData: any) {
    const pickupCtrl = <any>this.frmActivity;

    const locIdCtrl = pickupCtrl.controls["location_id"];
    const latCtrl = pickupCtrl.controls["lat"];
    const longCtrl = pickupCtrl.controls["lng"];
    const streetNoCtrl = pickupCtrl.controls["street_no"];
    const streetCtrl = pickupCtrl.controls["street"];
    const suburbCtrl = pickupCtrl.controls["suburb"];
    const stateCtrl = pickupCtrl.controls["state"];
    const postalCodeCtrl = pickupCtrl.controls["postal_code"];

    locIdCtrl.reset();
    latCtrl.reset();
    longCtrl.reset();
    streetNoCtrl.reset();
    streetCtrl.reset();
    suburbCtrl.reset();
    stateCtrl.reset();
    stateCtrl.reset();
    postalCodeCtrl.reset();

    if (typeof selectedData === 'string' || selectedData instanceof String)
      this.pointdata = selectedData;
    else
      this.pointdata = JSON.parse(JSON.stringify(selectedData));

    this.geometryValue = true
    if (selectedData) {
      this.mapObj = JSON.parse(JSON.stringify(selectedData));
      this.mapObj = this.mapObj.data;

      if (selectedData.response == true) {
        if (this.mapObj?.geometry) {
          this.geometryValue = true
          this.mapLat = this.mapObj.geometry.location.lat;
          this.mapLng = this.mapObj.geometry.location.lng;

          latCtrl.setValue(this.mapLat);
          longCtrl.setValue(this.mapLng);

          var arr = [];
          arr[0] = this.mapLat;
          arr[1] = this.mapLng;

          for (let result of this.mapObj.address_components) {
            if (result.types == "street_number")
              streetNoCtrl.setValue(result.short_name);
            if (result.types == "route")
              streetCtrl.setValue(result.short_name);
            if (result.types.includes("locality"))
              suburbCtrl.setValue(result.short_name);
            if (result.types.includes("administrative_area_level_1"))
              stateCtrl.setValue(result.short_name);
            if (result.types.includes("postal_code"))
              postalCodeCtrl.setValue(result.short_name);
          }

          let stateinfo = this.states.find(x => x.abbreviation === stateCtrl.value)
          if (stateinfo == undefined) this.geometryValue = false;
        } else this.geometryValue = false;
      }
    }
    this.checkDates();
    this.checkLocation();
    console.table({ geometry: this.geometryValue, formvalue: this.frmActivity.valid, datetime: this.checkDateTime })
  }

  public async saveEvent(row,action){

    row['start'] = concatDateTimeString(row.start_date, row.startdate_time);
    row['end'] =  concatDateTimeString(row.end_date, row.enddate_time);
    row['updated_by'] = this.user.id;
    
    this.spinner = true;
    if(action== 'actual'){
      if(this.selectedEvent.run_action_id != 12){
        row['state_id'] = this.states.find(x=>x.abbreviation == row.state).id;
        }
        else{
          row['state_id'] = null;
        }

        await this.dispatchService.updateEvent(row).toPromise().then(data=>{
          if(data['error'] !=true){
            this.toastr.success('', data['message'], {
              timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
            });
            this.getRun();
          } else {
            this.toastr.error('', data['message'], {
              timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
            });
          }
        }, err =>{
          this.toastr.error("Please try again.", "There was a problem with updating the event", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
      }
    
    else{
      row['state_id'] = this.states.find(x=>x.abbreviation == row.state).id;
      await this.dispatchService.updatePlannedDetails(row).toPromise().then(data=>{
        if(data['error'] !=true){
          this.toastr.success('', data['message'], {
            timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
          });
          this.getRun();
        } else {
          this.toastr.error('', data['message'], {
            timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
          });
        }
      }, err =>{
        this.toastr.error("Please try again.", "There was a problem with updating the event", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      });
    }
    this.spinner = false;
    this.closeModal();
  }

  public openModalRelease(r_id) {
    this.release_id = r_id;
    this.modalRef = this._modal.open(this.modalRelease, { size: 'xs', backdrop: 'static' });
  }

  async generateReleaseDocket() {
    this.spinner = true;
    const release_data = {
      id: this.release_id
    };
    await this.dispatchService.generateReleaseDocket(release_data).toPromise().then(data => {
      if (data['error'] != true) {
        this.toastr.success('', data['message'], {
          timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
        });
        this.getRun();
      } else {
        this.toastr.error('', data['message'], {
          timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
        });
      }
    }, err => {
      this.toastr.error("Please try again.", "Error in generating release docket for run_id" + this.runData['id'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    this.spinner = false;
    this.closeModal();
  }

  public openModalCollect(c_id) {
    this.collect_id = c_id;
    this.modalRef = this._modal.open(this.modalCollect, { size: 'xs', backdrop: 'static' });
  }

  async generateCollectDocket() {
    this.spinner = true;
    const collect_data = {
      id: this.collect_id,
      changeover_run_id: this.runData['changeover_run_id']
    };
    await this.dispatchService.generateCollectDocket(collect_data).toPromise().then(data => {
      if (data['error'] != true) {
        this.toastr.success('', data['message'], {
          timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
        });
        this.getRun();
      } else {
        this.toastr.error('', data['message'], {
          timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
        });
      }
    }, err => {
      this.toastr.error("Please try again.", "Error in generating collect docket for run_id" + this.runData['id'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    this.spinner = false;
    this.closeModal();
  }

  public openModalRunsheet() {
    this.modalRef = this._modal.open(this.modalRunsheet, { size: 'xs', backdrop: 'static' });
  }

  async generateRunsheet() {
    this.spinner = true;
    var connote_ids = [];
    for (let connotes of this.connotes) {
      connote_ids.push(connotes.id)
    }
    const local_data = {
      id: this.runData['id'],
      connotes: connote_ids
    };
    await this.dispatchService.generateRunsheet(local_data).toPromise().then(data => {
      if (data['error'] != true) {
        this.toastr.success('', data['message'], {
          timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
        });
        this.getRun();
      } else {
        this.toastr.error('', data['message'], {
          timeOut: 5000, positionClass: 'toast-top-full-width', progressBar: true
        });
      }
    }, err => {
      this.toastr.error("Please try again.", "Error in generating collect docket for run_id" + this.runData['id'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    this.spinner = false;
    this.closeModal();
  }

  public openModal(modal_id) {
    this.modalRef = this._modal.open(modal_id, { container: '.app', backdrop: 'static', size: 'xl' });
  }


  public sp_sdp: boolean = false;
  public sp_tripsheet: boolean = false;
  public sp_runsheet: boolean = false;
  public sp_manifest: boolean = false;
  public sp_drelease: boolean = false;
  public sp_dcollect: boolean = false;

  public success_sdp: boolean = false;
  public success_tripsheet: boolean = false;
  public success_runsheet: boolean = false;
  public success_drelease: boolean = false;
  public success_dcollect: boolean = false;

  public failed_sdp: boolean = false;
  public failed_tripsheet: boolean = false;
  public failed_runsheet: boolean = false;
  public failed_drelease: boolean = false;
  public failed_dcollect: boolean = false;
  public success_manifest: boolean = false;
  public failed_manifest: boolean = false;

  generateFile(trigger, obj_id) {
    switch (trigger) {
      //for sdp
      case 'sdp': {
        this.sp_sdp = true;
        this.dispatchService.generateSDP(this.runData.id, this.user.id, 'admin manual generate').subscribe(data => {
          if (data['error'] != true) {
            this.success_sdp = true;
            this.failed_sdp = false;
          } else {
            this.failed_sdp = true;
            this.success_sdp = false;
          };
          this.sp_sdp = false;
        }, err => {
          this.failed_sdp = true;
          this.success_sdp = false;
          this.sp_sdp = false;
        });
        break;
      };

      // for packaging label
      case 'packaging_label': {
        document.getElementById('sp_packaging_label' + obj_id.id).setAttribute('style', 'display:inline-block');
        var connote = this.connotes.find(obj => {
          return obj.id == obj_id.id;
        });
        if (this.runData.run_type_id != 3) {
          this.bookingsService.createPackagingLabel(obj_id.connote_id).subscribe(data => {
            if (data['error'] != true) {
              document.getElementById('success_packaging_label' + obj_id.id).setAttribute('style', 'display:inline');
              document.getElementById('failed_packaging_label' + obj_id.id).setAttribute('style', 'display:none');
            } else {
              document.getElementById('failed_packaging_label' + obj_id.id).setAttribute('style', 'display:inline');
              document.getElementById('success_packaging_label' + obj_id.id).setAttribute('style', 'display:none');
            };
            document.getElementById('sp_packaging_label' + obj_id.id).setAttribute('style', 'display:none');
          }, err => {
            document.getElementById('sp_packaging_label' + obj_id.id).setAttribute('style', 'display:none');
            document.getElementById('failed_packaging_label' + obj_id.id).setAttribute('style', 'display:inline');
            document.getElementById('success_packaging_label' + obj_id.id).setAttribute('style', 'display:none');
          });
        }
        break;
      };

      // for connote
      case 'connote': {
        document.getElementById('sp_connote' + obj_id.id).setAttribute('style', 'display:inline-block');
        var connote = this.connotes.find(obj => {
          return obj.id == obj_id.id;
        });
        if (this.runData.run_type_id == 1 && this.runData.plan_activities[0].length == 1) {
          this.bookingsService.generateLocalStartConnote(obj_id.connote_id, this.run_id).subscribe(data => {
            if (data['error'] != true) {
              document.getElementById('success_connote' + obj_id.id).setAttribute('style', 'display:inline');
              document.getElementById('failed_connote' + obj_id.id).setAttribute('style', 'display:none');
            } else {
              document.getElementById('failed_connote' + obj_id.id).setAttribute('style', 'display:inline');
              document.getElementById('success_connote' + obj_id.id).setAttribute('style', 'display:none');
            };
            document.getElementById('sp_connote' + obj_id.id).setAttribute('style', 'display:none');
          }, err => {
            document.getElementById('sp_connote' + obj_id.id).setAttribute('style', 'display:none');
            document.getElementById('failed_connote' + obj_id.id).setAttribute('style', 'display:inline');
            document.getElementById('success_connote' + obj_id.id).setAttribute('style', 'display:none');
          });
        }
        else {
          this.bookingsService.generateProcessingConnotesDoc(obj_id.connote_id, this.run_id).subscribe(data => {
            if (data['error'] != true) {
              document.getElementById('success_connote' + obj_id.id).setAttribute('style', 'display:inline');
              document.getElementById('failed_connote' + obj_id.id).setAttribute('style', 'display:none');
            } else {
              document.getElementById('failed_connote' + obj_id.id).setAttribute('style', 'display:inline');
              document.getElementById('success_connote' + obj_id.id).setAttribute('style', 'display:none');
            };
            document.getElementById('sp_connote' + obj_id.id).setAttribute('style', 'display:none');
          }, err => {
            document.getElementById('sp_connote' + obj_id.id).setAttribute('style', 'display:none');
            document.getElementById('failed_connote' + obj_id.id).setAttribute('style', 'display:inline');
            document.getElementById('success_connote' + obj_id.id).setAttribute('style', 'display:none');
          });
        }
        break;
      };

      //for tripsheet
      case 'tripsheet': {
        this.sp_tripsheet = true;
        this.dispatchService.generateTripsheet(this.runData.id, this.user.id).subscribe(data => {
          if (data['error'] != true) {
            this.success_tripsheet = true;
            this.failed_tripsheet = false;
          } else {
            this.failed_tripsheet = true;
            this.success_tripsheet = false;
          };
          this.sp_tripsheet = false;
        }, err => {
          this.sp_tripsheet = false;
          this.failed_tripsheet = true;
          this.success_tripsheet = false;
        });
        break;
      };

      //for manifest
      case 'manifest': {
        this.sp_manifest = true;
        this.dispatchService.generateManifest(this.runData.id).subscribe(data => {
          if (data['error'] != true) {
            this.success_manifest = true;
            this.failed_manifest = false;
          } else {
            this.failed_manifest = true;
            this.success_manifest = false;
          };
          this.sp_manifest = false;
        }, err => {
          this.sp_manifest = false;
          this.failed_manifest = true;
          this.success_manifest = false;
        });
        break;
      };

      //for runsheet
      case 'runsheet': {
        this.sp_runsheet = true;
        var connote_ids = [];
        for (let connotes of this.connotes) {
          connote_ids.push(connotes.id)
        }
        const local_data = {
          id: this.runData['id'],
          connotes: connote_ids
        };
        this.dispatchService.generateRunsheet(local_data).subscribe(data => {
          if (data['error'] != true) {
            this.success_runsheet = true;
            this.failed_runsheet = false;
          } else {
            this.failed_runsheet = true;
            this.success_runsheet = false;
          };
          this.sp_runsheet = false;
        }, err => {
          this.sp_runsheet = false;
          this.failed_runsheet = true;
          this.success_runsheet = false;
        });
        break;
      };

      //for release docket
      case 'release_docket': {
        this.sp_drelease = true;
        const release_data = {
          id: obj_id
        };
        this.dispatchService.generateReleaseDocket(release_data).subscribe(data => {
          if (data['error'] != true) {
            this.success_drelease = true;
            this.failed_drelease = false;
          } else {
            this.failed_drelease = true;
            this.success_drelease = false;
          };
          this.sp_drelease = false;
        }, err => {
          this.sp_drelease = false;
          this.failed_drelease = true;
          this.success_drelease = false;
        });
        break;
      };

      //for collect docket
      case 'collect_docket': {
        this.sp_dcollect = true;
        const collect_data = {
          id: obj_id,
          changeover_run_id: this.runData['changeover_run_id']
        };
        this.dispatchService.generateCollectDocket(collect_data).subscribe(data => {
          if (data['error'] != true) {
            this.success_dcollect = true;
            this.failed_dcollect = false;
          } else {
            this.failed_dcollect = true;
            this.success_dcollect = false;
          };
          this.sp_dcollect = false;
        }, err => {
          this.sp_dcollect = false;
          this.failed_dcollect = true;
          this.success_dcollect = false;
        });
        break;
      };

      default: break;
    };
  }

  resetDocVariables() {
    this.sp_sdp = false;
    this.sp_tripsheet = false;
    this.sp_runsheet = false;
    this.sp_drelease = false;
    this.sp_dcollect = false;
    this.success_sdp = false;
    this.success_tripsheet = false;
    this.success_runsheet = false;
    this.success_drelease = false;
    this.success_dcollect = false;
    this.failed_sdp = false;
    this.failed_tripsheet = false;
    this.failed_runsheet = false;
    this.failed_drelease = false;
    this.failed_dcollect = false;
  };

  editActivity(s) {
    this.activityForm = this._fb.group({
      id: [s.connote_site_id],
      notes: [s.connote_notes],
      contact_name: [s.connote_contact_name],
      contact_no: [s.connote_contact_no],
      contact_email: [s.connote_contact_email],
    });
    this.modalRef = this._modal.open(this.modalActivityInfo, { size: 'xs', backdrop: 'static' });
  }

  async onsubmitActivities(row) {
    this.spinner = true
    await this.bookingsService.updateConnoteSites(row).toPromise().then(data => {
      this.toastr.success('', data['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
      this.getRun();
    }, error => {
      this.toastr.error("Please try again.", "There was a problem with updating this activity", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });

    this.closeModal();
    this.spinner = false;
  }

  // View Driver in a new tab
  viewDriver(id) {
    if(this.isEnabled('Drivers')){
      const openIn = this.router.serializeUrl(
        this.router.createUrlTree(['/drivers/driverslist/driverdetails', { id: id }])
      );
      window.open(openIn, '_blank');
    }    
  }

  // View Fleet in a new tab
  viewFleet(id) {
    if(this.isEnabled('Fleet')){
      const openIn = this.router.serializeUrl(
        this.router.createUrlTree(['/fleet/listfleets/viewfleet', { id: id }])
      );
      window.open(openIn, '_blank');
    }
  }

  openDeallocateModal() {
    console.time('retrieving Dispatch info');
    this.errorMsg1 = ""; this.errorMsg2 = "";
    this.is_UpdateError = false; this.is_UpdateWarning = false;
    this.d_ModalLoader = true;
    this.deallocate();
    this.modalRef = this._modal.open(this.modalDeallocate, { size: 'xs', backdrop: 'static', centered: true });
  }

  getConnoteAddress(index: number) {
    const connote = this.connotesList[index];
    if (connote.activities.length > 0) {
      let route = ""
      const start = connote.activities[0];
      const end = connote.activities[connote.activities.length - 1];

      start?.location_id != null ? route = route + ((start.suburb != null) ? start?.suburb : start?.street) + " " +
        ((start.state_abbrev != null) ? start?.state_abbrev : " ") : route = route + "TBA";
      end?.location_id != null ? route = route + "-" + ((end.suburb != null) ? end?.suburb : start?.end) + " " +
        ((end.state_abbrev != null) ? end?.state_abbrev : " ") : route = route + "TBA";

      return route;
    } return "Location Unknown";
  }

  getConnoteStatus(index: number) {
    const connote = this.connotesList[index];
    const acts = connote.activities;

    if (acts.filter(x => x.is_done == true).length == acts.length) return 'Completed'; //completed - all activities are done
    else if (acts.filter(x => x.is_done == true).length >= 1) return 'Ongoing'; //processing - at least one activity is done
    else if (acts.filter(x => x.is_done == true).length == 0) return 'Pending'; //pending - no tasks done
  }

  checkDeallocateValidity() {  //checks if this run:
    if (this.runData.run_type_id != 1) { // is of LOCAL Job Type,
      return false;
    } else {
      if (this.runData.run_status_id != 4 && this.runData.run_status_id != 5) { // 2. if run not is cancelled or completed
        return true;
      } else return false;
    }
  }

  getConnotesForDeallocate(allTasksList) {
    let fullActList = []
    allTasksList.forEach(phases => {
      phases.forEach(acts => {
        fullActList.push(acts);
      });
    });

    let list = fullActList.filter(function (el) { return el.run_id != null });
    let final_list = [];

    list.forEach(li => {
      if (final_list.find(fl => fl.id == li.connote_id) == undefined) {
        let newCon = li.connote;

        newCon['activities'] = (fullActList.filter(x => x.connote_id == li.connote_id))
        newCon['checked'] = false;
        final_list.push(newCon);
      }
    });
    return final_list;
  }

  async deallocate() { //calls getrun to double check connotes' status
    await this.getRun();
    this.connotesList = this.getConnotesForDeallocate(this.runData['plan_activities']);
    this.d_ModalLoader = false;
  }

  deallocateCheck() {
    if (this.connotesList.filter(x => x.checked == true).length > 0) {
      return false
    } else return true
  }

  async submitDeallocate() {
    let row = []; this.spinner = true;
    let connotes = this.connotesList.filter(x => x.checked == true);

    connotes.forEach(x => {
      let con = this.connotes.find(y => y.id == x.id);
      if (con != undefined) {
        delete con.activities;
        row.push(con);
      }
    })

    await this.undoUpdate(row);
    console.log('removing connotes...');
  }

  async undoUpdate(row) {
    await this.localDispatchService.removeConnote(row, this.runData.id, this.user.id).toPromise().then(async data => {
      await this.getRun();
      this.getConnotesForDeallocate(this.runData['plan_activities']);

      this.is_UpdateError = data['error'];
      this.is_UpdateWarning = data['is_warning'];
      this.errorMsg1 = data['error_message'];
      this.errorMsg2 = data['error_message2'];

    }).catch(data => {
      if (data['error_message'] == null) {
        this.toastr.error('Please try again', 'There was a problem upon updating your dispatch.', {
          timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
        });
      } else if (data['error_message'] == ' ') {
        this.toastr.error('Please try again', 'There was a problem upon updating your dispatch.', {
          timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
        });
      } else {
        this.toastr.error('Please try again', data["error_message"], {
          timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
        });
      }
      this.spinner = false;
    }).finally(() => {
      this.spinner = false;
    });
  }

  async getVolvo() {
    this.volvo_loadingIndicator = true;
    let data = { "run_id": this.run_id, "vin": this.runData.vin, user_id: this.user.id }
    await this.dispatchService.getVolvo(data).toPromise().then(res => {
      this.volvo = res['volvo'];
      this.volvo_message = res['message'];
      this.volvo_result = res['result'];
      this.volvo_connect = true;
      this.volvo_loadingIndicator = false;
    })
  }

  checkListDisplay() {
    if (this.runData.run_status_id == 4 || this.runData.run_status_id == 5) {
      return false;
    } else if (this.connotesList.length > 0) {
      return true;
    } else return false;
  }

  initNCRForm() {
    this.NCRForm = this._fb.group({
      id: [''],
      category_id: ['', Validators.required],
      code_id: ['', Validators.required],
      classification_id: ['', Validators.required],
      driver_id:            [],
      fleet_id: [''],
      status_id: [''],
      problem_details: ['', Validators.required],
      customer_id: [''],
      file: [''],
      supporting_docs: [''],
      user_id: [''],
      run_control_no: ['']
    });
  }


  openNCRModal(NCR: NonCompliance): void {
    if (NCR) {
      this.isEditModeNCR = true;
      this.pushFleetModel = [];
      this.pushDriverModel = [];
      this.runData.equipment.forEach(el => {
        let temp = JSON.parse(NCR['fleet'])?.find(x => x == el.equipment_id);
        if (temp) {
          this.pushFleetModel.push(el.equipment_id)
        }
      })

      this.runData.driver.forEach(dr => {
        let drv = JSON.parse(NCR['driver_id'])?.find(y=> y == dr.driver_id);
          if(drv){
              this.pushDriverModel.push(dr.driver_id)
          }
      })

      if (NCR.supporting_docs != null && NCR.supporting_docs != '') {
        this.oldFile = NCR.supporting_docs;
        this.fileExists = true;
      }
      else {
        this.fileExists = false;
      }
      this.NCRForm.controls.run_control_no.setValue(this.runData.control_no);
      this.NCRForm.patchValue(NCR);
    }
    else {
      this.fileExists = false;
      this.isEditModeNCR = false;
    }
    this.NCRForm.controls.run_control_no.setValue(this.runData.control_no);
    this.modalRef = this._modal.open(this.modalNCR, { size: 'lg', backdrop: 'static' });
  }

  async onSubmitNCR(NCR: any) {
    NCR.fleet_id = this.pushFleetModel;
    NCR.driver_id = this.pushDriverModel;
    NCR.user_id = this.user.id
    this.spinner = true;
    NCR.frmFile = this.frmFile;
    if (this.frmFile) {
      await this.uploadFile(this.prefixNCR, NCR.supporting_docs);
    }
    if (NCR.id) {
      await this.ncrService.updateNCR(NCR).toPromise().then(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });

      }).catch(err => {
        this.toastr.error("Please try again.", "There was a problem with updating the selected ncr entry.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }).finally(() => {

      });
    }
    else {
      NCR.status_id = 1;
      await this.ncrService.createNCR(NCR).toPromise().then(result => {
        this.toastr.success('', result['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });

      }).catch(err => {
        this.toastr.error("Please try again.", "There was a problem with creating new ncr entry.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }).finally(() => {

      });
    }
    this.pushFleetModel = [];
    this.pushDriverModel =[];
    this.getRun();
    this.closeModal();
    this.spinner = false;
  }

  async uploadFile(caller, filename) {
    if (this.frmFile) {
      await this.fileService.uploadRawFile(caller, this.frmFile, filename).toPromise();
    }
    this.frmFile = '';

    //handling files if replaced, old file is removed from server
    if (this.fileRemove == true) {
      this.deleteFile(caller, this.oldFile);
    };
  }

  public getFile(event, caller) {

    var imgFilename;

    if (event == '' || event == null) {
      imgFilename = event;
      this.is_image = true;
    } else {
      var str = event.file.type.split("/");
      var a = str[str.length - 1];
      if (a.toLowerCase() == 'png' || a.toLowerCase() == 'jpg' || a.toLowerCase() == 'jpeg' || a.toLowerCase() == 'pdf') {
        var file: ImageResult;
        file = event;
        imgFilename = file.file.name;
        this.frmFile = event;
        this.is_image = true;
      }
      else {
        this.toastr.error('', 'File should be an image or pdf', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
        imgFilename = null;
        this.is_image = false;
      }
    }


    switch (caller) {
      case this.prefixNCR:
        {
          this.NCRForm.controls.supporting_docs.setValue(imgFilename); break;
        };
      default: break;
    }

  }

  public deleteFile(caller, filename) {
    this.fileService.deleteFile(caller, filename).subscribe(result => { console.log(result); })
    this.fileRemove = false;
  }

  public removeFile(caller) {
    this.fileExists = false;
    switch (caller) {
      case this.prefixNCR:
        {
          this.NCRForm.controls.supporting_docs.setValue(''); break;
        };
      default: break;
    }

    this.fileRemove = true;
  }

  public openModalDeleteNCR(ncr: NonCompliance) {
    this.objToDelete = ncr
    this.modalRef = this._modal.open(this.modalDeleteNCR, { container: '.app', backdrop: 'static' });
  }

  async deleteNCR(id: number) {
    this.spinner = true;

    await this.ncrService.deleteNCR(id).toPromise().then(result => {
      this.toastr.success('', result['message'], {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });

    }).catch(err => {
      this.toastr.error("Please try again.", "There was a problem with deleting the selected report.", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    }).finally(() => {
      this.getRun();
    });
    this.modalRef.close();
    this.spinner = false;
  }

  checkPushModel() {
    if (this.pushFleetModel) {
      if (this.pushFleetModel.length < 1)
        return false;
      else return true;
    }
    else return false;

  }

  checkDriverModel() {
    if (this.pushDriverModel) {
        if (this.pushDriverModel.length < 1){
          this.isDriverSelected = false;
          return false;
        }
        else { 
          this.isDriverSelected = true; return true; 
        }
    }
    else  this.isDriverSelected = false; return false;
}

  resetFormControl(type) {
    const pCtrl = (<any>this.NCRForm);
    pCtrl.controls.customer_id.setValue('');
  }

  public invalidateBreachRecord(id: any) {
    this.spinner = true;
    this.breachService.deleteBreachRecord(id)
      .pipe(
        tap(() => {
          this.processManifestBreach()
          this.closeModal()
        })
      )
      .subscribe({
        next: (record) => {
          this.spinner = false;
          this.toastr.success('', 'Successfully removed invalid location breach record', {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          })
        },
        error: (err) => {
          this.spinner = false;
          this.toastr.error("Please try again.", "Something went wrong while deleting the location breach record", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }
      })
  }

  public openModalDeleteBreach(id: number): void {
    this.breachId = null
    this.breachId = id
    this.modalRef = this._modal.open(this.modalDeleteBreachLocation, { size: 'lg', backdrop: 'static', centered: true });
  }

  /**
   * Assign the options here
   */
  driverSelectOption: IMultiSelectOption[];
  truckSelectOption: IMultiSelectOption[];
  trailerSelectOption: IMultiSelectOption[];

  /**
   * Configure the actions meant for selection
   */
  driverSelectSetting: IMultiSelectSettings = {
      enableSearch: true,
      checkedStyle: 'fontawesome',
      buttonClasses: 'btn btn-sm btn-secondary btn-block',
      dynamicTitleMaxItems: 2,
      minSelectionLimit: 1,
      selectionLimit: 2,
      displayAllSelectedText: true,
  };
  truckSelectSetting: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-sm btn-secondary btn-block',
    dynamicTitleMaxItems: 1,
    selectionLimit: 1,
    displayAllSelectedText: true,
  };
  trailerSelectSetting: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-sm btn-secondary btn-block',
    dynamicTitleMaxItems: 10,
    displayAllSelectedText: true,
  };

  /**
   * Configure the texts to be displayed
   */
  driverSelectText: IMultiSelectTexts = {
    checked: 'Item Selected',
    checkedPlural: 'Items Selected',
    searchPlaceholder: 'Find',
    defaultTitle: 'Select a Driver',
    allSelected: 'All Selected',
  };
  truckSelectText: IMultiSelectTexts = {
    checked: 'Item Selected',
    checkedPlural: 'Items Selected',
    searchPlaceholder: 'Find',
    defaultTitle: 'Select a Truck',
    allSelected: 'All Selected',
  };
  trailerSelectText: IMultiSelectTexts = {
    checked: 'Item Selected',
    checkedPlural: 'Items Selected',
    searchPlaceholder: 'Find',
    defaultTitle: 'Select a Trailer',
    allSelected: 'All Selected',
  };

  /**
   * Store the selected driver, truck and trailer when updating
   */
  frmJobEditForm: FormGroup;
  initJobEditForm(){
    this.frmJobEditForm = this._fb.group({
      run_route      :  [''],
      drivers        :  [''],
      truck          :  [''],
      trailers       :  this._fb.array([this.createTrailersFormGroup()]),
      task_delete    :  this._fb.array([]),
    })
  }

  createTrailersFormGroup(): FormGroup {
    return this._fb.group({
      phase: [null],
      trailer: []
    });
  }

  /**
   * Global declaration of multiple usage in switch-case
   */
  JOB_EDIT_TYPE = {
    DRIVER    : 'driver',
    TRUCK     : 'truck',
    TRAILER   : 'trailer'
  }

  /**
   * Assign the list of drivers, trucks, trailers as the options
   * @param options Contains list of data to be selected 
   * @param type Contains the string to match the param, options
   */
  setMultipleOptions(options = [], type: String){
    switch(type){
      case this.JOB_EDIT_TYPE.DRIVER: {
        for(let i=0; i< options.length; i++){
          options[i].name = options[i]['first_name'] + ' ' + options[i]['last_name'];
        }
        return options;
      }
      case this.JOB_EDIT_TYPE.TRUCK:{
        for(let i=0; i< options.length; i++){
          options[i].name = options[i]['rego'];
        }
        return options;
      }
      case this.JOB_EDIT_TYPE.TRAILER: {
        for(let i=0; i< options.length; i++){
          options[i].name = options[i]['rego'];
        }
        return options;
      }
      default: break;
    }
  }

  /**
   * Set the dispatched driver, truck, and trailer to the multiple selection as selected
   * @param currData Contains list of data to be displayed
   * @param type Contains the string to match the param, currData
   */
  patchDispatchedData(currData: any[]=[], type: String=''){
    switch(type){
      case this.JOB_EDIT_TYPE.DRIVER: {
        const driverArray = currData.map(data => data.driver_id);
        this.frmJobEditForm.patchValue({
          drivers: driverArray
        });
        break;
      }
      case this.JOB_EDIT_TYPE.TRUCK: {
        const truckArray = currData.map(data => data.equipment_id);
        this.frmJobEditForm.patchValue({
          truck: truckArray
        });
        break;
      }
      case this.JOB_EDIT_TYPE.TRAILER: {
        const trailers = this.frmJobEditForm.get('trailers') as FormArray;
        const phases = this.allTaskPhases.map((phaseArr, i) => {
          // Get dispatched trailer according to phase
          let phaseNum = i+1;
          let currTrailer;
          if(this.runData.changeover_run_id != null){
            currTrailer = currData
                          .filter(data => { return data.phase_order_number == phaseNum && data.is_active == 1})
                          .map(data => data.equipment_id);
          }else{
            currTrailer = currData
                          .filter(data => { return data.phase_order_number == phaseNum})
                          .map(data => data.equipment_id);
          }

          return this._fb.group({
            phase: [phaseNum],
            trailer: [currTrailer]
          });
        });
        trailers.controls.splice(0, trailers.length); // clear the existing FormArray
        phases.forEach(phase => trailers.push(phase)); // add the new FormGroups
        break;
      }
      default: break;
    }
  }

  /**
   * Returns the badge-pill class of action
   * 
   * @param action_id - id of task's run_action
   * @returns badge class
   */
  public actionBadgeDisplay(action_id: number): String{
    const driver_reject_actions = [3, 13, 18]; //release, reject, terminate job (add release)
    const empty_run_actions = [14, 15]; //ER start/end
    const driver_accept_actions = [5, 6, 12]; //start, end, accept
    const misc_actions = [7, 8, 9, 10, 11, 17] //breakdown, refuel, TR, TC, create(?), add collect

    let badge = '';

    //&& shorthand for single if-statement
    (action_id == 1) && (badge = 'badge-success');
    (action_id == 2) && (badge = 'badge-info');
    (action_id == 4) && (badge = 'badge-secondary');
    
    (misc_actions.includes(action_id)) && (badge = 'badge-dark');
    (empty_run_actions.includes(action_id)) && (badge = 'badge-warning');
    (driver_accept_actions.includes(action_id)) && (badge = 'badge-primary');
    (driver_reject_actions.includes(action_id)) && (badge = 'badge-danger');
        
    return badge;
  }

  /**
   * Returns task's full action name
   * 
   * @param action_id - id of task's run_action
   * @returns concatenated action of task
   */
  public actionNameDisplay(action_id: Number): String{
    const runType = this.runData.run_type_id;
    const excludeAppend = [5, 6, 8, 12, 13];

    let action = this.run_actions.find(a=>a.id == action_id);

    if(action == undefined) return '';

    let label: String = `${(runType == 1 && !excludeAppend.includes(action.id))? 'Local': ''} ${action.display_label} 
                         ${(action.id == 5 || action.id == 6)?'Trip':''} ${(action.id == 12 || action.id == 13)?'Job':''}`

    return label;
  }

  public locationStringDisplay(task: any){
    let locationString = '';
    let abbrev = (task.state)? task.state: task.state_abbrev;
    if(task.id == null || task.id == ''){
      (task.lat == '' && task.lng == '')? 
        locationString = 'Location to be announced' :
        locationString =  `${task.company_name ?? ''} ${task.street_no ?? ''} ${task.street ?? ''} ${task.suburb ?? ''} ${abbrev ?? ''}`;
    } else {
      (task.location_id==null && abbrev == null)? 
      locationString = 'Location to be announced' :
      locationString = `${task.company_name ?? ''} ${task.street_no ?? ''} ${task.street ?? ''} ${task.suburb ?? ''} ${abbrev ?? ''}`;
    }
    return locationString;
  }

  public taskActionList(){
    let filteredList = [];
    const actions_list = [1, 2, 3, 4, 9, 10, 14, 15];

    this.run_actions.forEach(act => {
      (actions_list.includes(act.id)) && filteredList.push(act);
    });

    return filteredList;
  }

  showLocDetails(){ this.showDetails = !this.showDetails;}

  saveEditChanges(){
    this.spinner = true;
    let {driver, truck, trailers, activities} = this.patchEditFormToModel(this.frmJobEditForm.value, this.allTaskPhases);
    let departure, deallocatedActs = this.frmJobEditForm.get('task_delete').value;

    if(this.runData.changeover_run_id != null){ // getting pickups for changeover
      let pickups = activities.filter(obj => [1,10,14].includes(obj.run_action_id));
      departure = pickups[pickups.length -1].end_datetime;
    } else {
      let pickups = activities.filter(obj => [1,4,5,10,14].includes(obj.run_action_id))
      if(pickups[0].run_action_id == 5){
        departure = pickups[0].start_datetime
      } else if(pickups[0].run_action_id == 14){
        departure = pickups[0].end_datetime
      } else departure = pickups[pickups.length -1].end_datetime;
    }

    let has_tba =  activities.filter(x=>{return (x.id == null && x.location == null) || (x.id && (x.location == null && x.location_id == null))});
    let run = {
      'run_id': this.runData.id,
      'has_emptyrun': (hasEmptyRun(activities)),
      'run_routes_id': parseInt(this.frmJobEditForm.get('run_route').value),
      'has_tba': (has_tba.length!=0),
      'user_id': this.user.id,
      'departure': departure,
      'driver': driver, 
      'truck': truck, 
      'trailers': trailers, 
      'activities':activities,
      'deallocated': deallocatedActs
    }
    console.log("RUNNNNNNNNNN",run);
    
    this.dispatchService.updateEditedRun(run).subscribe(data=>{
      console.log('Run Updated.');
      this.getRun();
      this.spinner = false;
      this.modalRef.close();
      this.toastr.success(data['message'], "", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    },
    (error) => {
      console.log('Error in updating run. ', error);
      this.toastr.error("There was a problem with updating the run. Please try again.", "Internal Server Error 500", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
      this.spinner = false;
    });
  }

  addPhaseEditForm(){
    this.allTaskPhases.push([]);

    // Add a new FormGroup to the end of the trailers FormArray
    const trailersArray = this.frmJobEditForm.get('trailers') as FormArray;
    trailersArray.push(this.createTrailersFormGroup());

    // Set the phase control of the new FormGroup to the last index in the array plus one
    const lastIndex = trailersArray.length - 1;
    const newFormGroup = trailersArray.at(lastIndex);
    newFormGroup.get('phase').setValue(lastIndex + 1);
  }

  private patchEditFormToModel(frmData, frmTasks){
    let roadTrain_order = 1, order_number = 1;
    let driver    : RunDriver[]       = [];
    let truck     : RunEquipment[]    = [];
    let trailers  : RunEquipment[]    = [];
    let activities: RunPlanActivity[] = [];
    
    const run_id = this.runData.id;
    const service = this.runData.service_type_id;
    const runType = this.runData.run_type_id;

    let geofence_default: GeofenceRadius = {
        run_index   : null,
        phase_index : null,
        site_index  : null,
        radius      : 250,
        created_by  : this.user.id.toString()
    }

    frmData.drivers.forEach((x, i:number) => {
      let drv = this.runData.driver.find(y=> y.driver_id == x);
      driver.push({
        id            : (drv)? drv.id: null,
        driver_id     : x,
        run_event_id  : (drv)? drv.run_event_id: null,
        run_id        : run_id,
        is_two_up     : i,
        is_active     : 1,
        created_at    : '',
        updated_at    : '',
        is_planned    : 1,
        is_changeover : 0,
      })  
    });

    frmData.truck.forEach((t, i:number) => {
      let trk = this.runData.equipment.find(y=> y.equipment_id == t);
      truck.push({
        id            : (trk)? trk.id: null,
        run_id        : run_id,
        equipment_id  : t,
        run_event_id  : (trk)? trk.run_event_id: null,
        gross_weight  : null,
        axle1         : null,
        axle2         : null,
        axle3         : null,
        axle4         : null,
        axle5         : null,
        axle6         : null,
        axle7         : null,
        is_active     : 1,
        created_at    : '',
        updated_at    : '',
        is_planned    : 1,
        is_changeover : 0,
        is_trailer    : 0,
        is_truck      : 1,
        trailer_order_number: 0,
        phase_order_number : 1 //default
      })  
    });

    frmTasks.forEach((phases, i:number) => {
      let test = true;
      let prev: any;
      frmData.trailers[i]['prev_trailers'] = [];
     this.phases.forEach((ph,x:number) => 
      {
        //Verify whether any new activities were added with the new phase
          let check = frmTasks[i].find(act=> ph.find(y =>y.id == act.id));

          if(check){

            //If not added, retrieve the previous phase order number in the sequence. 
            prev = changeTrailers(ph,check);
            if(prev){

              //get the previous trailers attached
              frmData.trailers[i]['prev_trailers'] = isChangeTrailers(this.runData.equipment, prev);
            }
            return test = false;
          } 
        
      })

      frmData.trailers[i]['added'] = test;
      phases.forEach(act => {
        activities.push({
          id              : (act.id!='')?act.id:null,
          run_id          : run_id,
          connote_id      : act.connote_id,
          run_action_id   : act.run_action_id,
          connote_site_id : (act.connote_site_id)?act.connote_site_id:null,
          order_number    : order_number,
          location_id     : act.location_id,
          start_datetime  : act.start_datetime,
          end_datetime    : act.end_datetime,
          created_by      : (act.created_by)? act.created_by: this.user.id,
          updated_by      : (act.created_by)? this.user.id: null,
          created_at      : '',
          updated_at      : '',
          connote_site    : null,
          location        : (act.location_id)? null: this.newLocation(act),
          geofence        : (act.id=='')? geofence_default: null,
          phase_order_number : (runType == 6 || service == 10)? i+1: 1 //default
        })
        order_number++;
      });
    });

        //find what phase order is currently active
        let active_phase =  activities.find(el => {
                let done = this.runData.actual_activities.find(act=> act.run_plan_activity_id == el.id && act.run_plan_activity_id != null);
                if(!done){
                  return el;
                } 
        });

        if (!active_phase) active_phase = this.runData.equipment.find(x=> x.is_active == 1 && x.is_trailer == 1);
        if(frmData.trailers.length  < active_phase.phase_order_number) active_phase.phase_order_number = frmData.trailers[frmData.trailers.length - 1].phase;

        frmData.trailers.forEach((p,x:number) => {
          p['trailer'].forEach((el, i:number) => {
            let trl = (p.prev_trailers) ? p.prev_trailers.find(y=> y.equipment_id == el) : this.runData.equipment.find(y=> y.equipment_id == el); 
            let order = i+1, status = 0;
            if(runType == 6){ //PUD
              // if current phase in loop matches active_phase, variable is_active is set to 1, otherwise 0
              status  = (x+1 == active_phase.phase_order_number)?  1:  0;
            } else status = 1;

            if (service != 10){
              let  subtype = this.allTrailers.find(st=> st.id == el);
              order = (p['trailer'].length < 2) ? order : (subtype.fleet_subtype_id == 4) ? 1 : 2;
            }
            trailers.push({
              id            : (p.added) ? null :(trl)? trl.id: null,
              equipment_id  : el,
              run_id        : run_id,
              run_event_id  : (p.added) ? null : (trl)? trl.run_event_id: null,
              gross_weight  : null,
              axle1         : null,
              axle2         : null,
              axle3         : null,
              axle4         : null,
              axle5         : null,
              axle6         : null,
              axle7         : null,
              is_active     : status,
              created_at    : '',
              updated_at    : '',
              is_planned    : 1,
              is_changeover : 0,
              is_trailer    : 1,
              is_truck      : 0,
              trailer_order_number: (service != 10)? order: roadTrain_order,
              phase_order_number : (runType == 6 || service == 10)? x+1: 1
            });
            if(service == 10) roadTrain_order++;
          });
        });

    if(service == 10) activities = sortRoadTrain(activities);
    return {driver, truck, trailers, activities};
  }

  private newLocation(act){
      if(act.lat == '' && act.lng == '') return null;
      let loc: Location =  {
        'id': null,
        'lat': act.lat,
        'lng': act.lng,
        'short_text': null,
        'long_text': null,
        'street_no': act.street_no,
        'street': act.street,
        'city': act.city,
        'suburb': act.suburb,
        'state_id': act.state_id,
        'state': act.state,
        'postal_code': act.postal_code,
        'created_at': this.user.id.toString(),
      }
      return loc;
  }

  checkForCompletedTasks(i: number){
    return (this.allTaskPhases[i].filter(x => x.is_done == true)).length > 0;
  }

  removeTask(id: number|null, index: number|null, run_id: number|null, phase: number){
    // Remove trailers by phase when task is not present
    const trailersArray = this.frmJobEditForm.get('trailers') as FormArray;
    if(id == null && index == null){
      trailersArray.removeAt(phase);
    }

    const editForm = this.frmJobEditForm.get('task_delete') as FormArray;
    if(id == null && index == null){ //removing phase
      this.allTaskPhases[phase].map(task=>{
        if(task.id) editForm.push(this._fb.control(task.id));
      })
      this.allTaskPhases.splice(phase, 1);
    } else {//removing task
      if(id != null && run_id == this.runData.id) editForm.push(this._fb.control(id));
      this.allTaskPhases[phase].splice(index, 1);
    }
    // Align contents of allTaskPhase along with plannedTask
    this.editorSetRoute();
    this.removeTaskFromPool();
  }

  /**
   * Flattens an array with a depth of 1 to a single array
   * @param taskArray 
   * @returns 
   */
  flattenTaskPhase(taskArray){
    let flattenedArray = [];
    for (let i = 0; i < taskArray.length; i++) {
      for (let j = 0; j < taskArray[i].length; j++) {
        flattenedArray.push(taskArray[i][j]);
      }
    }
    return flattenedArray;
  }

  /**
   * Remove tasks based from allTaskPhases list
   */
  removeTaskFromPool(){
    const flattenedTask = this.flattenTaskPhase(this.allTaskPhases);
    const filteredArr = flattenedTask.filter(obj1 => {
      return this.plannedTasks.some(obj2 => obj2.id === obj1.id);
    });
    this.plannedTasks = filteredArr;
  }

  public get connote() {
    const control = this.frmActivity.get('connote') as FormGroup;
    return <Connote | null> control.value;
  }

  public set connote(connote: Connote | undefined) {
    // this.connoteId = connote?.id ?? null;

    const control = this.frmActivity.get('connote') as FormGroup;

    if(connote) {
      control.enable();
      control.setValue(connote);
    }
    else {
      control.reset();
      control.disable();
    }
  }

  public set connoteSite(site: ConnoteSite | null) {
    const control1 = <any> this.frmActivity.get('connote_site_id');
    if(!site) {
      control1.reset();
      control1.disable();

      return;
    }

    control1.enable();
    control1.setValue(site);
  }
  
  createTask(frmValues, action){
    frmValues['connote_id'] = frmValues['connote'].id;
    frmValues['connote_control_no'] = frmValues['connote'].control_no;
    frmValues['run_action_id'] = parseInt(frmValues['run_action_id']);
    frmValues['state_id'] = this.states.find(x=>x.abbreviation == frmValues.state)?.id ?? null;
    frmValues['start_datetime'] = concatDateTimeString(frmValues.start_date, frmValues.startdate_time);
    frmValues['end_datetime'] = concatDateTimeString(frmValues.end_date, frmValues.enddate_time);
    frmValues['update_plan_type'] = action;

    if(action == 'new'){      
      this.pushToAllTaskPhases(frmValues);
      this.plannedTasks.push(frmValues);
      console.log("[Task in Edit Mode Created]");
    }
    if(action == 'update'){
      let idx = this.jobEditActivityBtn;
      this.allTaskPhases[idx[0]].splice(idx[1], 1, frmValues);
      console.log("[Task in Edit Mode Update]");
    }

    this.editorSetRoute();
    this.modalRef.close(this.modalAddTask);
  }

  pushToAllTaskPhases(row){
    const taskCount = this.allTaskPhases.length;
    this.allTaskPhases[taskCount-1].push(row);
  }

  checkLinehaul(allTasks, job_type, service_type){
      const act_list = extractActivities(allTasks);
      let errorString='';
      
      allTasks.forEach((phase, p_index) => {
        let phaseError='';
        if(phase.length){
          phaseError = this.perPhaseCombinations(phase);
          if(hasEmptyRun(act_list)){
            let emptyErrors = this.emptyRunCombinations(phase);
            if(emptyErrors!='') phaseError = `${phaseError}${emptyErrors!=''?'. ':''}${emptyErrors}`;
          } 
        } else phaseError = `Missing/Incomplete Activities`;

        if(phaseError!='') phaseError = `${this.errPrefix.TSK_PREFIX} ${phaseError} (on Phase ${p_index+1})`
        errorString = `${errorString}${(errorString!='' && phaseError !='')?'<br>':''}${phaseError}`;
      });
    
      if(job_type != 6 && service_type != 10){
        errorString = `${errorString!=''?errorString+'<br>':''}${checkDateTimeforErrors(act_list)}`;
      }
      
    
    return errorString;
  }

  // Editor Checkers
  standards = { 1: 'BFM', 2: 'AFM', 3: 'Standard Hours', 4: 'Standard Bus'}
  errPrefix = {
    'TRK_PREFIX': '*[Truck]:',
    'DRV_PREFIX': '*[Driver]:',
    'TRL_PREFIX': '*[Trailer]:',
    'TSK_PREFIX': '*[Task]:',
    'RT_PREFIX' : '*[Route]:'
  };

  editorSetRoute(){
    const act_list = extractActivities(this.allTaskPhases)
    
    if(act_list.length){
      const start = act_list[0]; const end = act_list[act_list.length-1];
      const control1 = this.frmJobEditForm.controls["run_route"];
      
      let route; //undefined
      if(areActPointsValid(start.run_action_id, end.run_action_id) == ''){
        let changeover = act_list.filter(obj => [3,4].includes(obj.run_action_id));
        
        if(changeover.length){
          route = this.routes.find(x=>x.start_state_id == start.state_id && 
            x.end_state_id == end.state_id && x.changeover_state_id == changeover[0].state_id);
        } else {
          route = this.routes.find(x=>x.start_state_id == start.state_id && 
            x.end_state_id == end.state_id && x.changeover_state_id == null);
        }
        //automatically adjusts form's run_route if it finds a matching route
        if(route) control1.setValue(route.id);
      }
    }
  }

  editorCheckRoute(){
    if(this.runData.run_type_id == 1) return ''; //route is not required in local jobs

    const route = this.routes.find(x=> x.id == this.frmJobEditForm.get('run_route').value);
    const act_list = extractActivities(this.allTaskPhases)
    
    if(act_list.length == 0) return '';

    const start = act_list[0];
    const end   = act_list[act_list.length-1];
    if(areActPointsValid(start.run_action_id, end.run_action_id) == ''){
      //check changeover
      let changeover = act_list.filter(obj => [3,4].includes(obj.run_action_id));
      //check tba
      if(act_list.find(x=> x.is_tba || x.location_id == null)!=undefined){
        if(changeover.length){
          return (start.state_id == route.start_state_id &&
            changeover[0].state_id == route.changeover_state_id)? 
            ``: `${this.errPrefix.RT_PREFIX} Selected Changeover route not applicable.`;
        } else {
          return start.state_id == route.start_state_id? ``:
            `${this.errPrefix.RT_PREFIX} Selected route not applicable.`;
        }
      } else {
        if(route.changeover_state_id){
           if(changeover != undefined){
            return (start.state_id == route.start_state_id && end.state_id == route.end_state_id &&
              changeover[0].state_id == route.changeover_state_id)? 
              ``: `${this.errPrefix.RT_PREFIX} Selected Changeover route not applicable.`;
           } else return `${this.errPrefix.RT_PREFIX} Changeover run is missing a Release/Collect.`
        } else {
          return start.state_id == route.start_state_id && end.state_id == route.end_state_id? ``:
          `${this.errPrefix.RT_PREFIX} Selected route not applicable.`;
        }
      }
    }
  }

  editorCheckDriver(){
    let checkerArr = [], driversInvolved = '';
    const service_type = this.runData.service_type_id, prefix = this.errPrefix.DRV_PREFIX;
    const {driver1, driver2} = getDriverInfo(this.frmJobEditForm.get('drivers').value, this.allDrivers);

    if(!driver1){return `${prefix} At least One (1) driver is required.`;}

    if(driver1.is_expired == 1){ //driver1
      return `${prefix} ${driver1.driver_name?? ''}'s license is expired.`;
    } else checkerArr.push(this.dispatchService.checkDriverLicence(service_type, driver1.license_class_id))

    if(driver2){ //driver2
      if(driver2.is_expired == 1){
        return `${prefix} ${driver2.driver_name?? ''}'s license is expired.`;
      } else checkerArr.push(this.dispatchService.checkDriverLicence(service_type, driver2.license_class_id))

      if(driver1.driver_standard_id != driver2?.driver_standard_id){
        return `${prefix} Drivers should have the same driver standard 
              (${driver1.driver_name} - ${this.standards[driver1.driver_standard_id]}/
              ${driver2.driver_name} - ${this.standards[driver2.driver_standard_id]})`;
      }
    }

    driversInvolved = `${(!checkerArr[0])? driver1.driver_name: ''} 
                       ${(!checkerArr[0] && !checkerArr[1] && driver2)? ' and ': ''} 
                       ${(driver2 && !checkerArr[1])?driver2.driver_name:''}`;
         
    return checkerArr.includes(false)
      ? `${prefix} License of ${driversInvolved?? ''} not applicable for this run.`
      : ``;
    }

  editorCheckTruck(){
    const {start, end} =  getTripDates(this.allTaskPhases);
    const service_type = this.runData.service_type_id, prefix = this.errPrefix.TRK_PREFIX;
    const _truck = getEquipmentInfo(this.frmJobEditForm.get('truck').value, this.allTrucks);
    
    let errorString = '', truckAvailability: boolean = true;

    (_truck == null)? (errorString =  `One (1) Required.`)
        : truckAvailability = this.dispatchService.checkFleet_EquipmentType(
          service_type,_truck[0].fleet_type_id, _truck[0].fleet_subtype_id);

    if(!truckAvailability && errorString == '') errorString = `${_truck[0].rego} is not applicable to service type.`;
    
    let expiry = checkRegobyMultiples(_truck, start, end);
    if(expiry !='') expiry = `${prefix} ${expiry}`;

    return (errorString != '') ? `${prefix} ${errorString}` : expiry;
  }

  editorCheckTrailers(){
    let editorTrailers:any[] = [];
    const {start, end} =  getTripDates(this.allTaskPhases);
    let service_type = this.runData.service_type_id, prefix = this.errPrefix.TRL_PREFIX;
    var isAllowed = false;
    if(this.runData['run_type_id'] != 6){
      isAllowed = this.runData['plan_activities'][0].some(act => act.connote.run_type_id == 4)
      
      if(isAllowed && this.runData['changeover_run_id']){
           var ac_planned:any;
           var tr_active =  this.runData['equipment'].find(eq =>eq.is_active == 1 && eq.is_trailer == 1);
           if (tr_active) {
              if(tr_active.is_planned == 1){
                ac_planned =  this.runData['plan_activities'][0].find(rp=>rp.run_action_id == 3);
                console.log("AC PLANNED RELEASE",ac_planned);
                if (ac_planned.connote.service_type != 3 &&  ac_planned.connote.service_type != 5) isAllowed = false; service_type = ac_planned.connote.service_type_id;
              }
              else{
                ac_planned =  this.runData['plan_activities'][0].find(rp=>rp.run_action_id == 4);
                console.log("AC PLANNED COLLECT",ac_planned);
                if (ac_planned.connote.service_type_id != 3 && ac_planned.connote.service_type_id != 5) isAllowed = false; service_type = ac_planned.connote.service_type_id;
              }

          }
          
      }
    }

    this.frmJobEditForm.get('trailers').value.forEach((trl, i) => {

      (trl.trailer == null)? editorTrailers.push({ 'phase': i, 'trailer': null})
                           : editorTrailers.push({ 'phase': i, 'trailer': getEquipmentInfo(trl.trailer, this.allTrailers)});
    });

    let trailerString = '', combinationString = '';
    editorTrailers.forEach((phase, index) =>{
      let checker = this.dispatchService.checkTrailer_EquipmentType(service_type, phase.trailer ?? [],isAllowed)
      if(checker.result == false){
          let phaseError = `${prefix} ${checker.error} (on Phase ${index+1})`;
         (index == 0)? combinationString = `${phaseError}`
                     : combinationString = `${combinationString}${combinationString !=''?'<br>':''}${phaseError}`;
        }
      //checks rego's expiry
      if(phase.trailer != null){
        let result = checkRegobyMultiples(phase.trailer, start, end);
        if(result != '') result = `${prefix} ${result} (on Phase ${index+1})`;
        (index == 0)? trailerString = `${result}`
                    : trailerString = `${trailerString}${result !=''? '<br>': ''}${result != ''? result:''}`;
      }
    })
    return `${trailerString}${(trailerString !='' && combinationString!= '')?'<br>r':''}${combinationString}`;
  }

  editorCheckActivities(){ //TODO: load check per run;
    const act_list = extractActivities(this.allTaskPhases)
    const job_type  = this.runData.run_type_id;
    const service_type  = this.runData.service_type_id;
    let actError = ''

    if(!act_list.length) return `${this.errPrefix.TSK_PREFIX} Tasks required`;
    switch(job_type){
      case 1: {
        const ls_count = hasActivity(5, act_list).length;
        if(ls_count != 0){
          if(ls_count > 1 || act_list.length != 1) return `${this.errPrefix.TSK_PREFIX} Only one Local Start is allowed`;
        } else actError = areActPointsValid(act_list[0].run_action_id, act_list[act_list.length-1].run_action_id);
        
        let higherConnotes = this.localDispatchService.checkAllowedServiceType(this.getConnotesForDeallocate(this.allTaskPhases), service_type);
        if(higherConnotes.length > 0) actError = `${this.errPrefix.TSK_PREFIX} ${concatConnotes(higherConnotes)}`;
        break;
      }
      case 2:
      case 3: //TODO: if activities is added in ER make sure run_type becomes linehaul job type
        actError = this.checkLinehaul(this.allTaskPhases, job_type, service_type);
        break;
      case 4: 
        actError = areActPointsValid(act_list[0].run_action_id, act_list[act_list.length-1].run_action_id);
        if(actError!='') actError = `${this.errPrefix.TSK_PREFIX} ${actError}`
        break;
      case 5: break;
      case 6: 
        actError = this.checkLinehaul(this.allTaskPhases, job_type, service_type);
        break;
    }

    let r = containsJobType(act_list, job_type,this.runData)
    if(r.length != act_list.length) actError = `${this.errPrefix.TSK_PREFIX} Manifest's Job Type and Tasks do not match`;

    return `${actError}`;
  }

  checkEditForm(){
    let _objErrors = { 
      driver    : this.editorCheckDriver() != '',
      truck     : this.editorCheckTruck() != '',
      trailers  : this.editorCheckTrailers() != '',
      tasks     : this.editorCheckActivities() != '',
      route     : this.editorCheckRoute()!=''
    }
    console.log("AAAAAAA",_objErrors);
    return (_objErrors.driver || _objErrors.truck || _objErrors.trailers 
      || _objErrors.tasks || _objErrors.route)? false : true;
    }

  private emptyRunCombinations(list:any[]){
    if(list.length >= 2){
      const startAction = list[0], endAction = list[1];
      return areActPointsValid(startAction.run_action_id, endAction.run_action_id, 'er');
    } return ` Missing or incorrect Empty Run combination`;
  }
  
  private perPhaseCombinations(acts){
    const TR = hasActivity(9, acts);
    const TC = hasActivity(10, acts);
    if(acts.length == 2 && (TR.length == 1 && TC.length == 1)){
      let check = areActPointsValid(acts[0].run_action_id, acts[1].run_action_id);
      if(check) return(TR[0].connote_id != TC[0].connote_id)? check: 
          `Allowed combination is Trailer Collect - Trailer Release`;
    } else {
      let allErrors = '';
      if(TR.length >= 1){
        let TR_errors = '';
        let prev_connote = TR[0].connote_id;
        TR.forEach((el, i) => {
          let err = '';
          if(i == 0 || prev_connote != el.connote_id){
            if(i != 0) prev_connote = el.connote_id;

            if(TR.filter(x=> x.connote_id == prev_connote).length > 1){
              err =  `Multiple Trailer Release for ${el.connote_control_no} cannot be on the same run!`
            }
            
            let deliveries = hasActivity(2,acts);
            if(deliveries.filter(x=>x.connote_id == prev_connote).length > 0){
              err =  `Trailer Release and Delivery tasks of ${el.connote_control_no} cannot be on the same run!`
            }
  
            (TR_errors!='' && err!='')? TR_errors = `${TR_errors}<br>`:null;
            TR_errors = `${TR_errors}${err}`;
          }
        });

        if(TR_errors !='') allErrors = TR_errors;
      } else if(TR.length >= 1){
        let TC_errors = '';
        let prev_connote = TC[0].connote_id;
        TC.forEach((el, i) => {
          let err = '';
          if(i == 0 || prev_connote != el.connote_id){
            if(i != 0) prev_connote = el.connote_id;

            if(TR.filter(x=> x.connote_id == prev_connote).length > 1){
              err =  `Multiple Trailer Collect for ${el.connote_control_no} cannot be on the same run`
            }
            
            let deliveries = hasActivity(2,acts);
            if(deliveries.filter(x=>x.connote_id == prev_connote).length > 0){
              err =  `Trailer Collect and Pickup tasks of ${el.connote_control_no} cannot be on the same run`
            }
  
            (TC_errors!='' && err!='')? TC_errors = `${TC_errors}<br>`:null;
            TC_errors = `${TC_errors}${err}`;
          }
        });
        if(TC_errors !='') allErrors = `${allErrors !=''?'<br>':''}${TC_errors}`;
      }

      return (allErrors !='')? allErrors: 
        areActPointsValid(acts[0].run_action_id, acts[acts.length-1].run_action_id);
    }

    return '';
  }

  isEnabled(name){
		let is_enabled = false;
		is_enabled = this.svc_components.isComponentEnabled(name);
		return is_enabled
	}
}

function checkDateTimeforErrors(list: any[]){ //do not use in roadtrain or PUD
  const suffix = ['th','st','nd','rd'];

  let first_act = list[0];
  for (let i = 0; i < list.length; i++) {
    const curr_act = list[i];

    if(i!=0){
      let start = new Date(first_act.end_datetime);
      let end = new Date(curr_act.start_datetime);
  
      if(isDateTimeGreater(start, end)){
        return `${i+1}${(suffix[i+1] || suffix[0])} task (${new Date(end).toLocaleString()}) 
                starts earlier than ${i}${(suffix[i] || suffix[0])} task (${new Date(start).toLocaleString()})`
      } else {
        if(isDateTimeSame(start, end) && first_act.run_action_id != curr_act.run_action_id){
          return `${i+1}${(suffix[i+1] || suffix[0])} task (${new Date(end).toLocaleString()}) 
                  has same time as ${i}${(suffix[i] || suffix[0])} task (${new Date(start).toLocaleString()})`
        } else first_act = curr_act;
      } 
    }
  }

  return '';
}

/**
 * Sort breaches ascending order
 */
function sortBreaches(Breach: BreachRequest[]) {
  return Breach.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
}

function extractActivities(runPlanActivities: any[]) {
  let plannedActivities = []
  runPlanActivities.forEach((act) => {
    plannedActivities.push(...act)
  })
  return plannedActivities
}

/**
 * Clone this.runData variable and extract run plan activities
 * @param Run Contains this.runData variable
 * @returns Cloned run data with extracted activities
 */
function cloneRun(Run: any) {
  let Clone = null
  Clone = { ...Run }
  Clone.plan_activities = extractActivities(Run.plan_activities)
  return Clone
}

/**
 * Segregate fleets by their fleet type. (Taken from editor.component.ts)
 * @param fleets List to segregate.
 * @returns Fleets, segregated by trucks, trailers and dollies.
 */
function segregateFleetsByType(fleets: Fleet[]) {
  const trucks  : Fleet[] = [];
  const trailers: Fleet[] = [];
  const dollies : Fleet[] = [];

  fleets.forEach((fleet) => {
    switch(fleet.fleet_type_id) {
      case 1:
      case 2:
      case 3:
        trucks.push(fleet);
        break;
      case 4:
        trailers.push(fleet);
        break;
      case 5:
        dollies.push(fleet);
        break;
    }
  })

  return { trucks, trailers, dollies };
}

/**
 * 
 * @param tasks list of tasks grouped by phase_order_number
 * @returns cloned copy of the tasks list 
 */
function clonePlannedTasks(tasks: any){
  tasks.forEach(el => {
    el.forEach((element) => {
      delete element.connote.activities;
    });
  }); 
 
  return JSON.parse(JSON.stringify(tasks));
}

function concatDateTimeString(date: String, time: any){
  return `${date} ${time.hour}:${time.minute}:00`; 
}

function getDriverInfo(drivers: any[], driverList: any[]){
  let driver1, driver2, info = null;
  
  for (let i = 0; i < drivers.length; i++) {
    const driver = driverList.find(x=>x.id == drivers[i]);

    (driver)? info = {
           'id': driver.id,
           'driver_standard_id': driver.driver_standard_id,
           'license_class_id': driver.license_class_id,
           'driver_name': `${driver.first_name} ${driver.last_name}`,
           'is_expired': driver.is_expired
          }: info = null;

    (i==0)? driver1 = info: driver2 = info;
  }

  return {driver1, driver2}
}

function getEquipmentInfo(equipment: any[], fleetList: any[]){
  let equipmentInfos = []

  if(equipment == null || equipment.length <= 0) return null;

  for (let i = 0; i < equipment.length; i++) {
    const eq = fleetList.find(x=>x.id == equipment[i]);
    equipmentInfos.push({
      'id': eq.id,
      'rego': eq.rego,
      'fleet_subtype_id': eq.fleet_subtype_id,
      'fleet_type_id': eq.fleet_type_id,
      'rego_due_date':  formatDate(eq.rego_due_date, 'yyyy-MM-dd', 'en_US'),
      'is_active': eq.is_active
    })
  }
  return equipmentInfos;
}

/**
 * Function intended for truck and trailer rego expiry check.
 * 
 * @param equipment list of equipments
 * @param taskList list of activities to compare dates
 */
function checkRegobyMultiples(equipment: any[], start:string, end:string){
  let listToday = [], listWithin = [];

  if(equipment != null){
    equipment.forEach(eq => {
      const check = checkRegoExpiry(eq.rego_expiry, start, end);
      if(check == 'today'){
        listToday.push(eq.rego);
      } else if (check == 'within'){
        listWithin.push(eq.rego);
      }
    });
  }

  return concatRegos(listToday, listWithin);
}

function concatRegos(listToday:Array<string>, listWithin:Array<string>){
  let regoString = '';

  if(listToday.length){
    for (let i = 0; i < listToday.length; i++) {
      const eq = listToday[i];
      (i==0)? regoString = eq: regoString = `${regoString}, ${eq}`;
    }
    regoString = `${regoString}'s Rego has expired`;
  }
  
  if(listWithin.length){
    for (let i = 0; i < listWithin.length; i++) {
      const eq = listWithin[i];
      (i==0)? regoString = eq: regoString = `${regoString}, ${eq}`;
    }
    regoString = `${regoString}'s Rego will expire within the run's duration`;
  }

  return regoString != ''? `${regoString}`: ``;
}

function concatConnotes(connotes:Array<any>){
  let conString = '';
  for (let i = 0; i < connotes.length; i++) {
    const eq = connotes[i];
    (i==0)? conString = eq.control_no: conString = `${conString}, ${eq.control_no}`;
  }
  return `${conString} have a higher load requirement than the run's service type`;
}

function checkRegoExpiry(rego_expiry: String, startdate: String, enddate: String){
  const today = formatDate( new Date(), 'yyyy-MM-dd', 'en_US');
    if (rego_expiry < today) return `today`;
    if(rego_expiry < startdate && rego_expiry < enddate) return `within`;
  return '';
}

function getTripDates(allTasks: any[]){
  let extractedActivities = extractActivities(allTasks);

  if(extractedActivities.length){
    extractedActivities.sort(function(a,b){
      var dateA = new Date(b.start_datetime).valueOf(), dateB = new Date(a.start_datetime).valueOf()
      return dateB - dateA || a.id - b.id});
    
      const start =  formatDate(extractedActivities[0].start_datetime, 'yyyy-MM-dd', 'en_US');
      const end = formatDate(extractedActivities[extractedActivities.length-1].start_datetime, 'yyyy-MM-dd', 'en_US');
      
      return { start, end }
  } else return {start: '', end: ''}
}

/**
 * checks if task action is valid based on what parameter is given
 * 
 * @param aStart first action in run
 * @param aEnd last action in run
 * @param type optional parameter to determine type
 * @returns string indicating error, empty if no errors
 */
function areActPointsValid(aStart, aEnd, type = null):string {
  const startPoints = [1,4,5,10,14], endPoints = [2,3,6,9,15], erPoints = [14,15];
  aStart = parseInt(aStart), aEnd = parseInt(aEnd);

  if(type === 'er'){
    if(erPoints[0] != aStart || erPoints[1] != aEnd)
      return `Incorrect Combination! Empty Run tasks should precede other tasks in the run`
  }

  if(type === 'changeover'){
    //
  }

  if(!startPoints.includes(aStart)) return `Task at the beginning of run is not a starting action`;
  if(!endPoints.includes(aEnd)) return `Task at the end of run is not a ending action`;

  return ''
  }

function hasEmptyRun(list){
  return (list.filter(x=>x.run_action_id == 14 || x.run_action_id == 15).length > 0)
}

function hasActivity(action:number, list:any[]){
  return list.filter(x => x.run_action_id == action);
}

function isDateTimeGreater(date1, date2){
  return new Date(date2) < new Date(date1);
}

function isDateTimeSame(date1, date2){
  return (date2.toISOString() == date1.toISOString());
}

function containsJobType(activities:Array<any>,job_type:number,runData){

  var changeover = runData['changeover_run_id'];

  return activities.filter(function(x){

    if(job_type == 6)
      return x.connote.run_type_id == 2 || x.connote.run_type_id == 6;

    if(changeover && x.connote.run_type_id == 4)
      return x.connote.run_type_id == 4
      
    if(job_type == 2 || job_type == 3)
      return x.connote.run_type_id == 2 || x.connote.run_type_id == 3;

    return x.connote.run_type_id == job_type;
  })
}

function sortRoutes(list, states) {
  let newList = list;
  newList.map((x)=>{
    const start = states.find(y => y.id == x.start_state_id);
    const end = states.find(y => y.id == x.end_state_id);
    const changeover = states.find(y => y.id == x.changeover_state_id);
    x['full_route'] = `[${start.name} (${start.abbreviation}) - ${(changeover!=undefined)? changeover.name + ' ('+changeover.abbreviation+') - ':''}${end.name} (${end.abbreviation})]`
  });
  return newList.sort((a, b) => a.description < b.description ? 1 : -1);
}

function sortRoadTrain(acts){
  const startPoints = [1,4,5,10,14], endPoints = [2,3,6,9,15];
  
  let startActs  = acts.filter(obj => startPoints.includes(obj.run_action_id));
  let endActs    = acts.filter(obj => endPoints.includes(obj.run_action_id));
  
  let count = 1; 
  let finalActs = [...startActs, ...endActs];

  finalActs.map(x => {x.order_number = count; count ++;})
  return finalActs;
}

function changeTrailers(phases, data){
  return phases.find(p=> p.id == data.id).phase_order_number
}

function isChangeTrailers(prevTrailers,phase_order_number){
  let ct = []
  prevTrailers.forEach(pt => {
        if(pt.phase_order_number == phase_order_number && pt.is_trailer == 1){
          ct.push(pt)
        }
  })
  return ct;

}
